// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { filterFromJson, filterGroupFromJson, filterGroupToJson, filterToJson } from '../../galaxytypes/v1/codec';
import { fieldMaskFromJson, fieldMaskToJson, pagedRequestOptionsFromJson, pagedRequestOptionsToJson, pagedResponseMetadataFromJson, pagedResponseMetadataToJson } from '../../vendastatypes/codec';
export function createFieldSchemaRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.fieldSchema !== undefined)
        o['fieldSchema'] = fieldSchemaToJson(m.fieldSchema);
    return o;
}
export function createFieldSchemaRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
        fieldSchema: o['fieldSchema'] ? fieldSchemaFromJson(o['fieldSchema']) : undefined,
    };
}
export function createFieldSchemaResponseToJson(m) {
    const o = {};
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    return o;
}
export function createFieldSchemaResponseFromJson(o) {
    var _a;
    return {
        fieldId: (_a = o['fieldId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getMultiFieldSchemaRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.fieldId !== undefined) {
        o['fieldId'] = m.fieldId.map(e => e);
    }
    if (m.locale !== undefined)
        o['locale'] = m.locale;
    return o;
}
export function getMultiFieldSchemaRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
        fieldId: ((_d = o['fieldId']) !== null && _d !== void 0 ? _d : []).map(e => e),
        locale: (_e = o['locale']) !== null && _e !== void 0 ? _e : '',
    };
}
export function getMultiFieldSchemaResponseToJson(m) {
    const o = {};
    if (m.fieldSchemas !== undefined) {
        o['fieldSchemas'] = m.fieldSchemas.map(e => fieldSchemaToJson(e));
    }
    return o;
}
export function getMultiFieldSchemaResponseFromJson(o) {
    var _a;
    return {
        fieldSchemas: ((_a = o['fieldSchemas']) !== null && _a !== void 0 ? _a : []).map(e => fieldSchemaFromJson(e)),
    };
}
export function listFieldSchemaRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.filters !== undefined)
        o['filters'] = listFieldSchemaRequestFiltersToJson(m.filters);
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.locale !== undefined)
        o['locale'] = m.locale;
    return o;
}
export function listFieldSchemaRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        filters: o['filters'] ? listFieldSchemaRequestFiltersFromJson(o['filters']) : undefined,
        searchTerm: (_d = o['searchTerm']) !== null && _d !== void 0 ? _d : '',
        locale: (_e = o['locale']) !== null && _e !== void 0 ? _e : '',
    };
}
export function listFieldSchemaRequestFiltersToJson(m) {
    const o = {};
    if (m.onlyArchived !== undefined)
        o['onlyArchived'] = m.onlyArchived;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function listFieldSchemaRequestFiltersFromJson(o) {
    var _a, _b;
    return {
        onlyArchived: (_a = o['onlyArchived']) !== null && _a !== void 0 ? _a : false,
        namespace: (_b = o['namespace']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listFieldSchemaResponseToJson(m) {
    const o = {};
    if (m.fieldSchemas !== undefined) {
        o['fieldSchemas'] = m.fieldSchemas.map(e => fieldSchemaToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listFieldSchemaResponseFromJson(o) {
    var _a;
    return {
        fieldSchemas: ((_a = o['fieldSchemas']) !== null && _a !== void 0 ? _a : []).map(e => fieldSchemaFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function listMultiLocationFieldSchemaRequestToJson(m) {
    const o = {};
    if (m.namespaces !== undefined) {
        o['namespaces'] = m.namespaces.map(e => e);
    }
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.filters !== undefined)
        o['filters'] = listMultiLocationFieldSchemaRequestFiltersToJson(m.filters);
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.locale !== undefined)
        o['locale'] = m.locale;
    return o;
}
export function listMultiLocationFieldSchemaRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        namespaces: ((_a = o['namespaces']) !== null && _a !== void 0 ? _a : []).map(e => e),
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        filters: o['filters'] ? listMultiLocationFieldSchemaRequestFiltersFromJson(o['filters']) : undefined,
        searchTerm: (_d = o['searchTerm']) !== null && _d !== void 0 ? _d : '',
        locale: (_e = o['locale']) !== null && _e !== void 0 ? _e : '',
    };
}
export function listMultiLocationFieldSchemaRequestFiltersToJson(m) {
    const o = {};
    if (m.onlyArchived !== undefined)
        o['onlyArchived'] = m.onlyArchived;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function listMultiLocationFieldSchemaRequestFiltersFromJson(o) {
    var _a, _b;
    return {
        onlyArchived: (_a = o['onlyArchived']) !== null && _a !== void 0 ? _a : false,
        namespace: (_b = o['namespace']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listMultiLocationFieldSchemaResponseToJson(m) {
    const o = {};
    if (m.fieldSchemas !== undefined) {
        o['fieldSchemas'] = m.fieldSchemas.map(e => fieldSchemaToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listMultiLocationFieldSchemaResponseFromJson(o) {
    var _a;
    return {
        fieldSchemas: ((_a = o['fieldSchemas']) !== null && _a !== void 0 ? _a : []).map(e => fieldSchemaFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function updateFieldSchemaRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.fieldSchema !== undefined)
        o['fieldSchema'] = fieldSchemaToJson(m.fieldSchema);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateFieldSchemaRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
        fieldSchema: o['fieldSchema'] ? fieldSchemaFromJson(o['fieldSchema']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function archiveFieldSchemaRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    return o;
}
export function archiveFieldSchemaRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
        fieldId: (_d = o['fieldId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function unarchiveFieldSchemaRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    return o;
}
export function unarchiveFieldSchemaRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
        fieldId: (_d = o['fieldId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function fieldSchemaToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    if (m.externalId !== undefined)
        o['externalId'] = m.externalId;
    if (m.fieldType !== undefined)
        o['fieldType'] = m.fieldType;
    if (m.fieldName !== undefined)
        o['fieldName'] = m.fieldName;
    if (m.fieldDescription !== undefined)
        o['fieldDescription'] = m.fieldDescription;
    if (m.dropdownOptions !== undefined) {
        o['dropdownOptions'] = m.dropdownOptions.map(e => dropdownOptionToJson(e));
    }
    if (m.currencyCode !== undefined)
        o['currencyCode'] = m.currencyCode;
    if (m.archived !== undefined)
        o['archived'] = m.archived.toISOString();
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.readonly !== undefined)
        o['readonly'] = m.readonly;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.skipAutomation !== undefined)
        o['skipAutomation'] = m.skipAutomation;
    if (m.uniqueness !== undefined)
        o['uniqueness'] = m.uniqueness;
    return o;
}
export function fieldSchemaFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        fieldId: (_b = o['fieldId']) !== null && _b !== void 0 ? _b : '',
        externalId: (_c = o['externalId']) !== null && _c !== void 0 ? _c : '',
        fieldType: (_d = o['fieldType']) !== null && _d !== void 0 ? _d : 'FIELD_TYPE_INVALID',
        fieldName: (_e = o['fieldName']) !== null && _e !== void 0 ? _e : '',
        fieldDescription: (_f = o['fieldDescription']) !== null && _f !== void 0 ? _f : '',
        dropdownOptions: ((_g = o['dropdownOptions']) !== null && _g !== void 0 ? _g : []).map(e => dropdownOptionFromJson(e)),
        currencyCode: (_h = o['currencyCode']) !== null && _h !== void 0 ? _h : '',
        archived: o['archived'] ? new Date(o['archived']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        readonly: (_j = o['readonly']) !== null && _j !== void 0 ? _j : false,
        crmObjectType: (_k = o['crmObjectType']) !== null && _k !== void 0 ? _k : '',
        crmObjectSubtype: (_l = o['crmObjectSubtype']) !== null && _l !== void 0 ? _l : '',
        skipAutomation: (_m = o['skipAutomation']) !== null && _m !== void 0 ? _m : false,
        uniqueness: (_o = o['uniqueness']) !== null && _o !== void 0 ? _o : 'FIELD_UNIQUENESS_NONE',
    };
}
export function dropdownOptionToJson(m) {
    const o = {};
    if (m.label !== undefined)
        o['label'] = m.label;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function dropdownOptionFromJson(o) {
    var _a, _b;
    return {
        label: (_a = o['label']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function createCrmObjectRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObject !== undefined)
        o['crmObject'] = crmObjectToJson(m.crmObject);
    return o;
}
export function createCrmObjectRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObject: o['crmObject'] ? crmObjectFromJson(o['crmObject']) : undefined,
    };
}
export function createCrmObjectResponseToJson(m) {
    const o = {};
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    return o;
}
export function createCrmObjectResponseFromJson(o) {
    var _a;
    return {
        crmObjectId: (_a = o['crmObjectId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateCrmObjectRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObject !== undefined)
        o['crmObject'] = crmObjectToJson(m.crmObject);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateCrmObjectRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObject: o['crmObject'] ? crmObjectFromJson(o['crmObject']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function getMultiCrmObjectRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectIds !== undefined) {
        o['crmObjectIds'] = m.crmObjectIds.map(e => e);
    }
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    if (m.projectionFilters !== undefined) {
        o['projectionFilters'] = m.projectionFilters.map(e => objectProjectionFilterToJson(e));
    }
    return o;
}
export function getMultiCrmObjectRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectIds: ((_b = o['crmObjectIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
        projectionFilters: ((_c = o['projectionFilters']) !== null && _c !== void 0 ? _c : []).map(e => objectProjectionFilterFromJson(e)),
    };
}
export function getMultiCrmObjectResponseToJson(m) {
    const o = {};
    if (m.crmObjects !== undefined) {
        o['crmObjects'] = m.crmObjects.map(e => crmObjectToJson(e));
    }
    if (m.fieldSchemas !== undefined) {
        o['fieldSchemas'] = m.fieldSchemas.map(e => fieldSchemaToJson(e));
    }
    return o;
}
export function getMultiCrmObjectResponseFromJson(o) {
    var _a, _b;
    return {
        crmObjects: ((_a = o['crmObjects']) !== null && _a !== void 0 ? _a : []).map(e => crmObjectFromJson(e)),
        fieldSchemas: ((_b = o['fieldSchemas']) !== null && _b !== void 0 ? _b : []).map(e => fieldSchemaFromJson(e)),
    };
}
export function objectProjectionFilterToJson(m) {
    const o = {};
    if (m.filterType !== undefined)
        o['filterType'] = m.filterType;
    if (m.fromFieldType !== undefined)
        o['fromFieldType'] = m.fromFieldType;
    if (m.toFieldType !== undefined)
        o['toFieldType'] = m.toFieldType;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    return o;
}
export function objectProjectionFilterFromJson(o) {
    var _a, _b, _c, _d;
    return {
        filterType: (_a = o['filterType']) !== null && _a !== void 0 ? _a : 'PROJECTION_FILTER_TYPE_INVALID',
        fromFieldType: (_b = o['fromFieldType']) !== null && _b !== void 0 ? _b : 'FIELD_TYPE_INVALID',
        toFieldType: (_c = o['toFieldType']) !== null && _c !== void 0 ? _c : 'FIELD_TYPE_INVALID',
        fieldId: (_d = o['fieldId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function deleteCrmObjectRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    return o;
}
export function deleteCrmObjectRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectId: (_b = o['crmObjectId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function restoreCrmObjectRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    return o;
}
export function restoreCrmObjectRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectId: (_b = o['crmObjectId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function crmObjectToJson(m) {
    const o = {};
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    if (m.externalId !== undefined)
        o['externalId'] = m.externalId;
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.fields !== undefined) {
        o['fields'] = m.fields.map(e => fieldValueToJson(e));
    }
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.groupId !== undefined)
        o['groupId'] = m.groupId;
    if (m.idempotencyId !== undefined)
        o['idempotencyId'] = m.idempotencyId;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function crmObjectFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        crmObjectId: (_a = o['crmObjectId']) !== null && _a !== void 0 ? _a : '',
        externalId: (_b = o['externalId']) !== null && _b !== void 0 ? _b : '',
        ownerId: (_c = o['ownerId']) !== null && _c !== void 0 ? _c : '',
        fields: ((_d = o['fields']) !== null && _d !== void 0 ? _d : []).map(e => fieldValueFromJson(e)),
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        groupId: (_e = o['groupId']) !== null && _e !== void 0 ? _e : '',
        idempotencyId: (_f = o['idempotencyId']) !== null && _f !== void 0 ? _f : '',
        crmObjectSubtype: (_g = o['crmObjectSubtype']) !== null && _g !== void 0 ? _g : '',
        namespace: (_h = o['namespace']) !== null && _h !== void 0 ? _h : '',
    };
}
export function stringListToJson(m) {
    const o = {};
    if (m.values !== undefined) {
        o['values'] = m.values.map(e => e);
    }
    return o;
}
export function stringListFromJson(o) {
    var _a;
    return {
        values: ((_a = o['values']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function geopointToJson(m) {
    const o = {};
    if (m.lat !== undefined)
        o['lat'] = m.lat;
    if (m.lon !== undefined)
        o['lon'] = m.lon;
    return o;
}
export function geopointFromJson(o) {
    var _a, _b;
    return {
        lat: (_a = o['lat']) !== null && _a !== void 0 ? _a : 0,
        lon: (_b = o['lon']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function currencyToJson(m) {
    const o = {};
    if (m.currencyCode !== undefined)
        o['currencyCode'] = m.currencyCode;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function currencyFromJson(o) {
    var _a, _b;
    return {
        currencyCode: (_a = o['currencyCode']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function timerToJson(m) {
    const o = {};
    if (m.duration !== undefined)
        o['duration'] = m.duration;
    if (m.originalStart !== undefined)
        o['originalStart'] = m.originalStart.toISOString();
    if (m.currentStart !== undefined)
        o['currentStart'] = m.currentStart.toISOString();
    if (m.originalEnd !== undefined)
        o['originalEnd'] = m.originalEnd.toISOString();
    if (m.currentEnd !== undefined)
        o['currentEnd'] = m.currentEnd.toISOString();
    if (m.status !== undefined)
        o['status'] = m.status;
    return o;
}
export function timerFromJson(o) {
    var _a, _b;
    return {
        duration: (_a = o['duration']) !== null && _a !== void 0 ? _a : 0,
        originalStart: o['originalStart'] ? new Date(o['originalStart']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        currentStart: o['currentStart'] ? new Date(o['currentStart']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        originalEnd: o['originalEnd'] ? new Date(o['originalEnd']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        currentEnd: o['currentEnd'] ? new Date(o['currentEnd']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : 'TIMER_STATUS_INVALID',
    };
}
export function fieldValueToJson(m) {
    const o = {};
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    if (m.externalId !== undefined)
        o['externalId'] = m.externalId;
    if (m.value !== undefined) {
        if (m.value.type === 'nullValue') {
            o['nullValue'] = m.value.nullValue;
        }
        if (m.value.type === 'integerValue') {
            o['integerValue'] = m.value.integerValue;
        }
        if (m.value.type === 'stringValue') {
            o['stringValue'] = m.value.stringValue;
        }
        if (m.value.type === 'dateValue') {
            o['dateValue'] = m.value.dateValue.toISOString();
        }
        if (m.value.type === 'booleanValue') {
            o['booleanValue'] = m.value.booleanValue;
        }
        if (m.value.type === 'stringValues') {
            o['stringValues'] = stringListToJson(m.value.stringValues);
        }
        if (m.value.type === 'geopointValue') {
            o['geopointValue'] = geopointToJson(m.value.geopointValue);
        }
        if (m.value.type === 'floatValue') {
            o['floatValue'] = m.value.floatValue;
        }
        if (m.value.type === 'phoneFieldValues') {
            o['phoneFieldValues'] = phoneFieldsToJson(m.value.phoneFieldValues);
        }
        if (m.value.type === 'currencyValue') {
            o['currencyValue'] = currencyToJson(m.value.currencyValue);
        }
        if (m.value.type === 'timerValue') {
            o['timerValue'] = timerToJson(m.value.timerValue);
        }
    }
    else {
        if (m.nullValue !== undefined)
            o['nullValue'] = m.nullValue;
        if (m.integerValue !== undefined)
            o['integerValue'] = m.integerValue;
        if (m.stringValue !== undefined)
            o['stringValue'] = m.stringValue;
        if (m.dateValue !== undefined)
            o['dateValue'] = m.dateValue.toISOString();
        if (m.booleanValue !== undefined)
            o['booleanValue'] = m.booleanValue;
        if (m.stringValues !== undefined)
            o['stringValues'] = stringListToJson(m.stringValues);
        if (m.geopointValue !== undefined)
            o['geopointValue'] = geopointToJson(m.geopointValue);
        if (m.floatValue !== undefined)
            o['floatValue'] = m.floatValue;
        if (m.phoneFieldValues !== undefined)
            o['phoneFieldValues'] = phoneFieldsToJson(m.phoneFieldValues);
        if (m.currencyValue !== undefined)
            o['currencyValue'] = currencyToJson(m.currencyValue);
        if (m.timerValue !== undefined)
            o['timerValue'] = timerToJson(m.timerValue);
    }
    return o;
}
export function fieldValueFromJson(o) {
    var _a, _b;
    return {
        fieldId: (_a = o['fieldId']) !== null && _a !== void 0 ? _a : '',
        externalId: (_b = o['externalId']) !== null && _b !== void 0 ? _b : '',
        value: (() => {
            if (o['nullValue'] !== undefined)
                return { type: 'nullValue', nullValue: o['nullValue'] };
            if (o['integerValue'] !== undefined)
                return { type: 'integerValue', integerValue: o['integerValue'] };
            if (o['stringValue'] !== undefined)
                return { type: 'stringValue', stringValue: o['stringValue'] };
            if (o['dateValue'] !== undefined)
                return { type: 'dateValue', dateValue: o['dateValue'] ? new Date(o['dateValue']) : undefined };
            if (o['booleanValue'] !== undefined)
                return { type: 'booleanValue', booleanValue: o['booleanValue'] };
            if (o['stringValues'] !== undefined)
                return { type: 'stringValues', stringValues: o['stringValues'] ? stringListFromJson(o['stringValues']) : undefined };
            if (o['geopointValue'] !== undefined)
                return { type: 'geopointValue', geopointValue: o['geopointValue'] ? geopointFromJson(o['geopointValue']) : undefined };
            if (o['floatValue'] !== undefined)
                return { type: 'floatValue', floatValue: o['floatValue'] };
            if (o['phoneFieldValues'] !== undefined)
                return { type: 'phoneFieldValues', phoneFieldValues: o['phoneFieldValues'] ? phoneFieldsFromJson(o['phoneFieldValues']) : undefined };
            if (o['currencyValue'] !== undefined)
                return { type: 'currencyValue', currencyValue: o['currencyValue'] ? currencyFromJson(o['currencyValue']) : undefined };
            if (o['timerValue'] !== undefined)
                return { type: 'timerValue', timerValue: o['timerValue'] ? timerFromJson(o['timerValue']) : undefined };
            return undefined;
        })(),
        nullValue: o['nullValue'] !== undefined ? o['nullValue'] : undefined,
        integerValue: o['integerValue'] !== undefined ? o['integerValue'] : undefined,
        stringValue: o['stringValue'] !== undefined ? o['stringValue'] : undefined,
        dateValue: o['dateValue'] !== undefined ? o['dateValue'] ? new Date(o['dateValue']) : undefined : undefined,
        booleanValue: o['booleanValue'] !== undefined ? o['booleanValue'] : undefined,
        stringValues: o['stringValues'] !== undefined ? o['stringValues'] ? stringListFromJson(o['stringValues']) : undefined : undefined,
        geopointValue: o['geopointValue'] !== undefined ? o['geopointValue'] ? geopointFromJson(o['geopointValue']) : undefined : undefined,
        floatValue: o['floatValue'] !== undefined ? o['floatValue'] : undefined,
        phoneFieldValues: o['phoneFieldValues'] !== undefined ? o['phoneFieldValues'] ? phoneFieldsFromJson(o['phoneFieldValues']) : undefined : undefined,
        currencyValue: o['currencyValue'] !== undefined ? o['currencyValue'] ? currencyFromJson(o['currencyValue']) : undefined : undefined,
        timerValue: o['timerValue'] !== undefined ? o['timerValue'] ? timerFromJson(o['timerValue']) : undefined : undefined,
    };
}
export function phoneFieldsToJson(m) {
    const o = {};
    if (m.isoCountryCode !== undefined)
        o['isoCountryCode'] = m.isoCountryCode;
    if (m.nationalNumber !== undefined)
        o['nationalNumber'] = m.nationalNumber;
    if (m.extension !== undefined)
        o['extension'] = m.extension;
    if (m.e164Compliant !== undefined)
        o['e164Compliant'] = m.e164Compliant;
    return o;
}
export function phoneFieldsFromJson(o) {
    var _a, _b, _c, _d;
    return {
        isoCountryCode: (_a = o['isoCountryCode']) !== null && _a !== void 0 ? _a : '',
        nationalNumber: (_b = o['nationalNumber']) !== null && _b !== void 0 ? _b : '',
        extension: (_c = o['extension']) !== null && _c !== void 0 ? _c : '',
        e164Compliant: (_d = o['e164Compliant']) !== null && _d !== void 0 ? _d : false,
    };
}
export function crmObjectSearchToJson(m) {
    const o = {};
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    return o;
}
export function crmObjectSearchFromJson(o) {
    var _a;
    return {
        searchTerm: (_a = o['searchTerm']) !== null && _a !== void 0 ? _a : '',
    };
}
export function sortByToJson(m) {
    const o = {};
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    if (m.sortDirection !== undefined)
        o['sortDirection'] = m.sortDirection;
    return o;
}
export function sortByFromJson(o) {
    var _a, _b;
    return {
        fieldId: (_a = o['fieldId']) !== null && _a !== void 0 ? _a : '',
        sortDirection: (_b = o['sortDirection']) !== null && _b !== void 0 ? _b : 'SORT_DIRECTION_INVALID',
    };
}
export function listCrmObjectsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.search !== undefined)
        o['search'] = crmObjectSearchToJson(m.search);
    if (m.sortBy !== undefined) {
        o['sortBy'] = m.sortBy.map(e => sortByToJson(e));
    }
    if (m.filtersV2 !== undefined)
        o['filtersV2'] = filterGroupToJson(m.filtersV2);
    if (m.projectionFilters !== undefined) {
        o['projectionFilters'] = m.projectionFilters.map(e => objectProjectionFilterToJson(e));
    }
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    return o;
}
export function listCrmObjectsRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        search: o['search'] ? crmObjectSearchFromJson(o['search']) : undefined,
        sortBy: ((_b = o['sortBy']) !== null && _b !== void 0 ? _b : []).map(e => sortByFromJson(e)),
        filtersV2: o['filtersV2'] ? filterGroupFromJson(o['filtersV2']) : undefined,
        projectionFilters: ((_c = o['projectionFilters']) !== null && _c !== void 0 ? _c : []).map(e => objectProjectionFilterFromJson(e)),
        crmObjectSubtype: (_d = o['crmObjectSubtype']) !== null && _d !== void 0 ? _d : '',
    };
}
export function listCrmObjectsResponseToJson(m) {
    const o = {};
    if (m.crmObjects !== undefined) {
        o['crmObjects'] = m.crmObjects.map(e => crmObjectToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listCrmObjectsResponseFromJson(o) {
    var _a;
    return {
        crmObjects: ((_a = o['crmObjects']) !== null && _a !== void 0 ? _a : []).map(e => crmObjectFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function listMultiLocationCrmObjectsRequestToJson(m) {
    const o = {};
    if (m.namespaces !== undefined) {
        o['namespaces'] = m.namespaces.map(e => e);
    }
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.search !== undefined)
        o['search'] = crmObjectSearchToJson(m.search);
    if (m.sortBy !== undefined) {
        o['sortBy'] = m.sortBy.map(e => sortByToJson(e));
    }
    if (m.filtersV2 !== undefined)
        o['filtersV2'] = filterGroupToJson(m.filtersV2);
    if (m.projectionFilters !== undefined) {
        o['projectionFilters'] = m.projectionFilters.map(e => objectProjectionFilterToJson(e));
    }
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    return o;
}
export function listMultiLocationCrmObjectsRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespaces: ((_a = o['namespaces']) !== null && _a !== void 0 ? _a : []).map(e => e),
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        search: o['search'] ? crmObjectSearchFromJson(o['search']) : undefined,
        sortBy: ((_b = o['sortBy']) !== null && _b !== void 0 ? _b : []).map(e => sortByFromJson(e)),
        filtersV2: o['filtersV2'] ? filterGroupFromJson(o['filtersV2']) : undefined,
        projectionFilters: ((_c = o['projectionFilters']) !== null && _c !== void 0 ? _c : []).map(e => objectProjectionFilterFromJson(e)),
        crmObjectSubtype: (_d = o['crmObjectSubtype']) !== null && _d !== void 0 ? _d : '',
    };
}
export function listMultiLocationCrmObjectsResponseToJson(m) {
    const o = {};
    if (m.crmObjects !== undefined) {
        o['crmObjects'] = m.crmObjects.map(e => crmObjectToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listMultiLocationCrmObjectsResponseFromJson(o) {
    var _a;
    return {
        crmObjects: ((_a = o['crmObjects']) !== null && _a !== void 0 ? _a : []).map(e => crmObjectFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function validateCrmObjectRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObject !== undefined)
        o['crmObject'] = crmObjectToJson(m.crmObject);
    return o;
}
export function validateCrmObjectRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObject: o['crmObject'] ? crmObjectFromJson(o['crmObject']) : undefined,
    };
}
export function validateCrmObjectResponseToJson(m) {
    const o = {};
    if (m.errors !== undefined) {
        o['errors'] = m.errors.map(e => validateCrmObjectResponseValidationErrorToJson(e));
    }
    return o;
}
export function validateCrmObjectResponseFromJson(o) {
    var _a;
    return {
        errors: ((_a = o['errors']) !== null && _a !== void 0 ? _a : []).map(e => validateCrmObjectResponseValidationErrorFromJson(e)),
    };
}
export function validateCrmObjectResponseUniquenessCheckToJson(m) {
    const o = {};
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    if (m.existingCrmObjectIds !== undefined) {
        o['existingCrmObjectIds'] = m.existingCrmObjectIds.map(e => e);
    }
    if (m.uniqueness !== undefined)
        o['uniqueness'] = m.uniqueness;
    return o;
}
export function validateCrmObjectResponseUniquenessCheckFromJson(o) {
    var _a, _b, _c;
    return {
        fieldId: (_a = o['fieldId']) !== null && _a !== void 0 ? _a : '',
        existingCrmObjectIds: ((_b = o['existingCrmObjectIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
        uniqueness: (_c = o['uniqueness']) !== null && _c !== void 0 ? _c : 'FIELD_UNIQUENESS_INVALID',
    };
}
export function validateCrmObjectResponseValidationErrorDetailsToJson(m) {
    const o = {};
    if (m.fieldIds !== undefined) {
        o['fieldIds'] = m.fieldIds.map(e => e);
    }
    if (m.details !== undefined) {
        if (m.details.type === 'uniquenessCheck') {
            o['uniquenessCheck'] = validateCrmObjectResponseUniquenessCheckToJson(m.details.uniquenessCheck);
        }
    }
    else {
        if (m.uniquenessCheck !== undefined)
            o['uniquenessCheck'] = validateCrmObjectResponseUniquenessCheckToJson(m.uniquenessCheck);
    }
    return o;
}
export function validateCrmObjectResponseValidationErrorDetailsFromJson(o) {
    var _a;
    return {
        fieldIds: ((_a = o['fieldIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        details: (() => {
            if (o['uniquenessCheck'] !== undefined)
                return { type: 'uniquenessCheck', uniquenessCheck: o['uniquenessCheck'] ? validateCrmObjectResponseUniquenessCheckFromJson(o['uniquenessCheck']) : undefined };
            return undefined;
        })(),
        uniquenessCheck: o['uniquenessCheck'] !== undefined ? o['uniquenessCheck'] ? validateCrmObjectResponseUniquenessCheckFromJson(o['uniquenessCheck']) : undefined : undefined,
    };
}
export function validateCrmObjectResponseValidationErrorToJson(m) {
    const o = {};
    if (m.ruleId !== undefined)
        o['ruleId'] = m.ruleId;
    if (m.message !== undefined)
        o['message'] = m.message;
    if (m.severity !== undefined)
        o['severity'] = m.severity;
    if (m.details !== undefined)
        o['details'] = validateCrmObjectResponseValidationErrorDetailsToJson(m.details);
    return o;
}
export function validateCrmObjectResponseValidationErrorFromJson(o) {
    var _a, _b, _c;
    return {
        ruleId: (_a = o['ruleId']) !== null && _a !== void 0 ? _a : '',
        message: (_b = o['message']) !== null && _b !== void 0 ? _b : '',
        severity: (_c = o['severity']) !== null && _c !== void 0 ? _c : 'VALIDATION_ERROR_SEVERITY_UNKNOWN',
        details: o['details'] ? validateCrmObjectResponseValidationErrorDetailsFromJson(o['details']) : undefined,
    };
}
export function listFieldOptionsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    return o;
}
export function listFieldOptionsRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        fieldId: (_b = o['fieldId']) !== null && _b !== void 0 ? _b : '',
        pageSize: (_c = o['pageSize']) !== null && _c !== void 0 ? _c : 0,
        searchTerm: (_d = o['searchTerm']) !== null && _d !== void 0 ? _d : '',
        crmObjectSubtype: (_e = o['crmObjectSubtype']) !== null && _e !== void 0 ? _e : '',
    };
}
export function listFieldOptionsResponseToJson(m) {
    const o = {};
    if (m.options !== undefined) {
        o['options'] = m.options.map(e => e);
    }
    return o;
}
export function listFieldOptionsResponseFromJson(o) {
    var _a;
    return {
        options: ((_a = o['options']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function listMultiLocationFieldOptionsRequestToJson(m) {
    const o = {};
    if (m.namespaces !== undefined) {
        o['namespaces'] = m.namespaces.map(e => e);
    }
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    return o;
}
export function listMultiLocationFieldOptionsRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespaces: ((_a = o['namespaces']) !== null && _a !== void 0 ? _a : []).map(e => e),
        fieldId: (_b = o['fieldId']) !== null && _b !== void 0 ? _b : '',
        pageSize: (_c = o['pageSize']) !== null && _c !== void 0 ? _c : 0,
        searchTerm: (_d = o['searchTerm']) !== null && _d !== void 0 ? _d : '',
    };
}
export function listMultiLocationFieldOptionsResponseToJson(m) {
    const o = {};
    if (m.options !== undefined) {
        o['options'] = m.options.map(e => e);
    }
    return o;
}
export function listMultiLocationFieldOptionsResponseFromJson(o) {
    var _a;
    return {
        options: ((_a = o['options']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function startBulkCompanyCreateRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.crmObjects !== undefined) {
        o['crmObjects'] = m.crmObjects.map(e => crmObjectToJson(e));
    }
    return o;
}
export function startBulkCompanyCreateRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        searchTerm: (_b = o['searchTerm']) !== null && _b !== void 0 ? _b : '',
        crmObjects: ((_c = o['crmObjects']) !== null && _c !== void 0 ? _c : []).map(e => crmObjectFromJson(e)),
    };
}
export function startBulkCompanyCreateResponseToJson(m) {
    const o = {};
    if (m.filterTag !== undefined)
        o['filterTag'] = m.filterTag;
    return o;
}
export function startBulkCompanyCreateResponseFromJson(o) {
    var _a;
    return {
        filterTag: (_a = o['filterTag']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getOpportunityValueSummaryRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.filters !== undefined)
        o['filters'] = filterGroupToJson(m.filters);
    return o;
}
export function getOpportunityValueSummaryRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        filters: o['filters'] ? filterGroupFromJson(o['filters']) : undefined,
    };
}
export function getOpportunityValueSummaryResponseToJson(m) {
    const o = {};
    if (m.stages !== undefined) {
        o['stages'] = m.stages.map(e => getOpportunityValueSummaryResponseStageAmountsToJson(e));
    }
    if (m.pipeline !== undefined)
        o['pipeline'] = getOpportunityValueSummaryResponseAmountsToJson(m.pipeline);
    return o;
}
export function getOpportunityValueSummaryResponseFromJson(o) {
    var _a;
    return {
        stages: ((_a = o['stages']) !== null && _a !== void 0 ? _a : []).map(e => getOpportunityValueSummaryResponseStageAmountsFromJson(e)),
        pipeline: o['pipeline'] ? getOpportunityValueSummaryResponseAmountsFromJson(o['pipeline']) : undefined,
    };
}
export function getOpportunityValueSummaryResponseAmountsToJson(m) {
    const o = {};
    if (m.total !== undefined)
        o['total'] = currencyToJson(m.total);
    if (m.estimated !== undefined)
        o['estimated'] = currencyToJson(m.estimated);
    return o;
}
export function getOpportunityValueSummaryResponseAmountsFromJson(o) {
    return {
        total: o['total'] ? currencyFromJson(o['total']) : undefined,
        estimated: o['estimated'] ? currencyFromJson(o['estimated']) : undefined,
    };
}
export function getOpportunityValueSummaryResponseStageAmountsToJson(m) {
    const o = {};
    if (m.stageId !== undefined)
        o['stageId'] = m.stageId;
    if (m.amounts !== undefined)
        o['amounts'] = getOpportunityValueSummaryResponseAmountsToJson(m.amounts);
    return o;
}
export function getOpportunityValueSummaryResponseStageAmountsFromJson(o) {
    var _a;
    return {
        stageId: (_a = o['stageId']) !== null && _a !== void 0 ? _a : '',
        amounts: o['amounts'] ? getOpportunityValueSummaryResponseAmountsFromJson(o['amounts']) : undefined,
    };
}
export function bulkDeleteCrmObjectsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.search !== undefined)
        o['search'] = crmObjectSearchToJson(m.search);
    if (m.filters !== undefined)
        o['filters'] = filterGroupToJson(m.filters);
    return o;
}
export function bulkDeleteCrmObjectsRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectSubtype: (_b = o['crmObjectSubtype']) !== null && _b !== void 0 ? _b : '',
        search: o['search'] ? crmObjectSearchFromJson(o['search']) : undefined,
        filters: o['filters'] ? filterGroupFromJson(o['filters']) : undefined,
    };
}
export function createActivityRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.activity !== undefined)
        o['activity'] = activityToJson(m.activity);
    if (m.autoPopulatePrimaryCompany !== undefined)
        o['autoPopulatePrimaryCompany'] = m.autoPopulatePrimaryCompany;
    if (m.autoPopulateOptions !== undefined)
        o['autoPopulateOptions'] = createActivityRequestAutoPopulateOptionsToJson(m.autoPopulateOptions);
    return o;
}
export function createActivityRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        activity: o['activity'] ? activityFromJson(o['activity']) : undefined,
        autoPopulatePrimaryCompany: (_b = o['autoPopulatePrimaryCompany']) !== null && _b !== void 0 ? _b : false,
        autoPopulateOptions: o['autoPopulateOptions'] ? createActivityRequestAutoPopulateOptionsFromJson(o['autoPopulateOptions']) : undefined,
    };
}
export function createActivityRequestAutoPopulateOptionsToJson(m) {
    const o = {};
    if (m.primaryCompany !== undefined)
        o['primaryCompany'] = m.primaryCompany;
    if (m.ignoreSalesperson !== undefined)
        o['ignoreSalesperson'] = m.ignoreSalesperson;
    return o;
}
export function createActivityRequestAutoPopulateOptionsFromJson(o) {
    var _a, _b;
    return {
        primaryCompany: (_a = o['primaryCompany']) !== null && _a !== void 0 ? _a : false,
        ignoreSalesperson: (_b = o['ignoreSalesperson']) !== null && _b !== void 0 ? _b : false,
    };
}
export function createActivityResponseToJson(m) {
    const o = {};
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    return o;
}
export function createActivityResponseFromJson(o) {
    var _a;
    return {
        crmObjectId: (_a = o['crmObjectId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateActivityRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.activity !== undefined)
        o['activity'] = activityToJson(m.activity);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateActivityRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        activity: o['activity'] ? activityFromJson(o['activity']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function getMultiActivityRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectIds !== undefined) {
        o['crmObjectIds'] = m.crmObjectIds.map(e => e);
    }
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    if (m.projectionFilters !== undefined) {
        o['projectionFilters'] = m.projectionFilters.map(e => objectProjectionFilterToJson(e));
    }
    return o;
}
export function getMultiActivityRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectIds: ((_b = o['crmObjectIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
        projectionFilters: ((_c = o['projectionFilters']) !== null && _c !== void 0 ? _c : []).map(e => objectProjectionFilterFromJson(e)),
    };
}
export function getMultiActivityResponseToJson(m) {
    const o = {};
    if (m.activities !== undefined) {
        o['activities'] = m.activities.map(e => activityToJson(e));
    }
    if (m.fieldSchemas !== undefined) {
        o['fieldSchemas'] = m.fieldSchemas.map(e => fieldSchemaToJson(e));
    }
    return o;
}
export function getMultiActivityResponseFromJson(o) {
    var _a, _b;
    return {
        activities: ((_a = o['activities']) !== null && _a !== void 0 ? _a : []).map(e => activityFromJson(e)),
        fieldSchemas: ((_b = o['fieldSchemas']) !== null && _b !== void 0 ? _b : []).map(e => fieldSchemaFromJson(e)),
    };
}
export function deleteActivityRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    return o;
}
export function deleteActivityRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectId: (_b = o['crmObjectId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function restoreActivityRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    return o;
}
export function restoreActivityRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectId: (_b = o['crmObjectId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function activityAssociationToJson(m) {
    const o = {};
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    return o;
}
export function activityAssociationFromJson(o) {
    var _a, _b, _c, _d;
    return {
        crmObjectId: (_a = o['crmObjectId']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        tags: ((_c = o['tags']) !== null && _c !== void 0 ? _c : []).map(e => e),
        crmObjectSubtype: (_d = o['crmObjectSubtype']) !== null && _d !== void 0 ? _d : '',
    };
}
export function activityToJson(m) {
    const o = {};
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.externalId !== undefined)
        o['externalId'] = m.externalId;
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.fields !== undefined) {
        o['fields'] = m.fields.map(e => fieldValueToJson(e));
    }
    if (m.associations !== undefined) {
        o['associations'] = m.associations.map(e => activityAssociationToJson(e));
    }
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function activityFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        crmObjectId: (_a = o['crmObjectId']) !== null && _a !== void 0 ? _a : '',
        crmObjectSubtype: (_b = o['crmObjectSubtype']) !== null && _b !== void 0 ? _b : '',
        externalId: (_c = o['externalId']) !== null && _c !== void 0 ? _c : '',
        ownerId: (_d = o['ownerId']) !== null && _d !== void 0 ? _d : '',
        fields: ((_e = o['fields']) !== null && _e !== void 0 ? _e : []).map(e => fieldValueFromJson(e)),
        associations: ((_f = o['associations']) !== null && _f !== void 0 ? _f : []).map(e => activityAssociationFromJson(e)),
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        namespace: (_g = o['namespace']) !== null && _g !== void 0 ? _g : '',
    };
}
export function listActivitiesRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.search !== undefined)
        o['search'] = crmObjectSearchToJson(m.search);
    if (m.sortBy !== undefined) {
        o['sortBy'] = m.sortBy.map(e => sortByToJson(e));
    }
    if (m.filtersV2 !== undefined)
        o['filtersV2'] = filterGroupToJson(m.filtersV2);
    return o;
}
export function listActivitiesRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectId: (_b = o['crmObjectId']) !== null && _b !== void 0 ? _b : '',
        crmObjectType: (_c = o['crmObjectType']) !== null && _c !== void 0 ? _c : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        search: o['search'] ? crmObjectSearchFromJson(o['search']) : undefined,
        sortBy: ((_d = o['sortBy']) !== null && _d !== void 0 ? _d : []).map(e => sortByFromJson(e)),
        filtersV2: o['filtersV2'] ? filterGroupFromJson(o['filtersV2']) : undefined,
    };
}
export function listActivitiesResponseToJson(m) {
    const o = {};
    if (m.activities !== undefined) {
        o['activities'] = m.activities.map(e => activityToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listActivitiesResponseFromJson(o) {
    var _a;
    return {
        activities: ((_a = o['activities']) !== null && _a !== void 0 ? _a : []).map(e => activityFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function listMultiLocationActivitiesRequestToJson(m) {
    const o = {};
    if (m.namespaces !== undefined) {
        o['namespaces'] = m.namespaces.map(e => e);
    }
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.search !== undefined)
        o['search'] = crmObjectSearchToJson(m.search);
    if (m.sortBy !== undefined) {
        o['sortBy'] = m.sortBy.map(e => sortByToJson(e));
    }
    if (m.filtersV2 !== undefined)
        o['filtersV2'] = filterGroupToJson(m.filtersV2);
    return o;
}
export function listMultiLocationActivitiesRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespaces: ((_a = o['namespaces']) !== null && _a !== void 0 ? _a : []).map(e => e),
        crmObjectId: (_b = o['crmObjectId']) !== null && _b !== void 0 ? _b : '',
        crmObjectType: (_c = o['crmObjectType']) !== null && _c !== void 0 ? _c : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        search: o['search'] ? crmObjectSearchFromJson(o['search']) : undefined,
        sortBy: ((_d = o['sortBy']) !== null && _d !== void 0 ? _d : []).map(e => sortByFromJson(e)),
        filtersV2: o['filtersV2'] ? filterGroupFromJson(o['filtersV2']) : undefined,
    };
}
export function listMultiLocationActivitiesResponseToJson(m) {
    const o = {};
    if (m.activities !== undefined) {
        o['activities'] = m.activities.map(e => activityToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listMultiLocationActivitiesResponseFromJson(o) {
    var _a;
    return {
        activities: ((_a = o['activities']) !== null && _a !== void 0 ? _a : []).map(e => activityFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function validateActivityRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.activity !== undefined)
        o['activity'] = activityToJson(m.activity);
    return o;
}
export function validateActivityRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        activity: o['activity'] ? activityFromJson(o['activity']) : undefined,
    };
}
export function validateActivityResponseToJson(m) {
    const o = {};
    if (m.errors !== undefined) {
        o['errors'] = m.errors.map(e => validateActivityResponseValidationErrorToJson(e));
    }
    return o;
}
export function validateActivityResponseFromJson(o) {
    var _a;
    return {
        errors: ((_a = o['errors']) !== null && _a !== void 0 ? _a : []).map(e => validateActivityResponseValidationErrorFromJson(e)),
    };
}
export function validateActivityResponseValidationErrorToJson(m) {
    const o = {};
    if (m.ruleId !== undefined)
        o['ruleId'] = m.ruleId;
    if (m.message !== undefined)
        o['message'] = m.message;
    return o;
}
export function validateActivityResponseValidationErrorFromJson(o) {
    var _a, _b;
    return {
        ruleId: (_a = o['ruleId']) !== null && _a !== void 0 ? _a : '',
        message: (_b = o['message']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getActivityMetricsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.metricTypes !== undefined) {
        o['metricTypes'] = m.metricTypes.map(e => e);
    }
    if (m.filters !== undefined)
        o['filters'] = filterGroupToJson(m.filters);
    return o;
}
export function getActivityMetricsRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        metricTypes: ((_b = o['metricTypes']) !== null && _b !== void 0 ? _b : []).map(e => e),
        filters: o['filters'] ? filterGroupFromJson(o['filters']) : undefined,
    };
}
export function getActivityMetricsResponseToJson(m) {
    const o = {};
    if (m.ownerMetricCounts !== undefined) {
        o['ownerMetricCounts'] = m.ownerMetricCounts.map(e => ownerMetricCountsToJson(e));
    }
    if (m.summaries !== undefined) {
        o['summaries'] = m.summaries.map(e => metricSummaryToJson(e));
    }
    return o;
}
export function getActivityMetricsResponseFromJson(o) {
    var _a, _b;
    return {
        ownerMetricCounts: ((_a = o['ownerMetricCounts']) !== null && _a !== void 0 ? _a : []).map(e => ownerMetricCountsFromJson(e)),
        summaries: ((_b = o['summaries']) !== null && _b !== void 0 ? _b : []).map(e => metricSummaryFromJson(e)),
    };
}
export function ownerMetricCountsToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.metricCounts !== undefined) {
        o['metricCounts'] = m.metricCounts.map(e => metricCountToJson(e));
    }
    return o;
}
export function ownerMetricCountsFromJson(o) {
    var _a, _b;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
        metricCounts: ((_b = o['metricCounts']) !== null && _b !== void 0 ? _b : []).map(e => metricCountFromJson(e)),
    };
}
export function metricCountToJson(m) {
    const o = {};
    if (m.metricType !== undefined)
        o['metricType'] = m.metricType;
    if (m.count !== undefined)
        o['count'] = m.count;
    return o;
}
export function metricCountFromJson(o) {
    var _a, _b;
    return {
        metricType: (_a = o['metricType']) !== null && _a !== void 0 ? _a : 'METRIC_TYPE_INVALID',
        count: (_b = o['count']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function metricSummaryToJson(m) {
    const o = {};
    if (m.metricType !== undefined)
        o['metricType'] = m.metricType;
    if (m.total !== undefined)
        o['total'] = m.total;
    if (m.average !== undefined)
        o['average'] = m.average;
    return o;
}
export function metricSummaryFromJson(o) {
    var _a, _b, _c;
    return {
        metricType: (_a = o['metricType']) !== null && _a !== void 0 ? _a : 'METRIC_TYPE_INVALID',
        total: (_b = o['total']) !== null && _b !== void 0 ? _b : 0,
        average: (_c = o['average']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function bulkDeleteActivitiesRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.search !== undefined)
        o['search'] = crmObjectSearchToJson(m.search);
    if (m.filters !== undefined)
        o['filters'] = filterGroupToJson(m.filters);
    return o;
}
export function bulkDeleteActivitiesRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        search: o['search'] ? crmObjectSearchFromJson(o['search']) : undefined,
        filters: o['filters'] ? filterGroupFromJson(o['filters']) : undefined,
    };
}
export function fieldSchemaCustomizationToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    if (m.restrictedFieldValues !== undefined) {
        o['restrictedFieldValues'] = m.restrictedFieldValues.map(e => fieldValueToJson(e));
    }
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.forceReadOnly !== undefined)
        o['forceReadOnly'] = m.forceReadOnly;
    return o;
}
export function fieldSchemaCustomizationFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        fieldId: (_b = o['fieldId']) !== null && _b !== void 0 ? _b : '',
        restrictedFieldValues: ((_c = o['restrictedFieldValues']) !== null && _c !== void 0 ? _c : []).map(e => fieldValueFromJson(e)),
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        forceReadOnly: (_d = o['forceReadOnly']) !== null && _d !== void 0 ? _d : false,
    };
}
export function createFieldSchemaCustomizationRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.fieldSchemaCustomization !== undefined)
        o['fieldSchemaCustomization'] = fieldSchemaCustomizationToJson(m.fieldSchemaCustomization);
    return o;
}
export function createFieldSchemaCustomizationRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        fieldSchemaCustomization: o['fieldSchemaCustomization'] ? fieldSchemaCustomizationFromJson(o['fieldSchemaCustomization']) : undefined,
    };
}
export function getMultiFieldSchemaCustomizationRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.fieldId !== undefined) {
        o['fieldId'] = m.fieldId.map(e => e);
    }
    return o;
}
export function getMultiFieldSchemaCustomizationRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        fieldId: ((_c = o['fieldId']) !== null && _c !== void 0 ? _c : []).map(e => e),
    };
}
export function getMultiFieldSchemaCustomizationResponseToJson(m) {
    const o = {};
    if (m.fieldSchemaCustomizations !== undefined) {
        o['fieldSchemaCustomizations'] = m.fieldSchemaCustomizations.map(e => fieldSchemaCustomizationToJson(e));
    }
    return o;
}
export function getMultiFieldSchemaCustomizationResponseFromJson(o) {
    var _a;
    return {
        fieldSchemaCustomizations: ((_a = o['fieldSchemaCustomizations']) !== null && _a !== void 0 ? _a : []).map(e => fieldSchemaCustomizationFromJson(e)),
    };
}
export function updateFieldSchemaCustomizationRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.fieldSchemaCustomization !== undefined)
        o['fieldSchemaCustomization'] = fieldSchemaCustomizationToJson(m.fieldSchemaCustomization);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateFieldSchemaCustomizationRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        fieldSchemaCustomization: o['fieldSchemaCustomization'] ? fieldSchemaCustomizationFromJson(o['fieldSchemaCustomization']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function deleteFieldSchemaCustomizationRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    return o;
}
export function deleteFieldSchemaCustomizationRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        fieldId: (_c = o['fieldId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listFieldSchemaCustomizationRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listFieldSchemaCustomizationRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listFieldSchemaCustomizationResponseToJson(m) {
    const o = {};
    if (m.fieldSchemaCustomizations !== undefined) {
        o['fieldSchemaCustomizations'] = m.fieldSchemaCustomizations.map(e => fieldSchemaCustomizationToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listFieldSchemaCustomizationResponseFromJson(o) {
    var _a;
    return {
        fieldSchemaCustomizations: ((_a = o['fieldSchemaCustomizations']) !== null && _a !== void 0 ? _a : []).map(e => fieldSchemaCustomizationFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function filterDefinitionToJson(m) {
    const o = {};
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    if (m.hasFilterOptions !== undefined)
        o['hasFilterOptions'] = m.hasFilterOptions;
    if (m.fieldName !== undefined)
        o['fieldName'] = m.fieldName;
    if (m.typeV2 !== undefined)
        o['typeV2'] = m.typeV2;
    if (m.supportedOperatorsV2 !== undefined) {
        o['supportedOperatorsV2'] = m.supportedOperatorsV2.map(e => e);
    }
    return o;
}
export function filterDefinitionFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        fieldId: (_a = o['fieldId']) !== null && _a !== void 0 ? _a : '',
        hasFilterOptions: (_b = o['hasFilterOptions']) !== null && _b !== void 0 ? _b : false,
        fieldName: (_c = o['fieldName']) !== null && _c !== void 0 ? _c : '',
        typeV2: (_d = o['typeV2']) !== null && _d !== void 0 ? _d : 'FILTER_TYPE_INVALID',
        supportedOperatorsV2: ((_e = o['supportedOperatorsV2']) !== null && _e !== void 0 ? _e : []).map(e => e),
    };
}
export function listFiltersRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.paging !== undefined)
        o['paging'] = pagedRequestOptionsToJson(m.paging);
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.locale !== undefined)
        o['locale'] = m.locale;
    return o;
}
export function listFiltersRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        paging: o['paging'] ? pagedRequestOptionsFromJson(o['paging']) : undefined,
        searchTerm: (_b = o['searchTerm']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
        locale: (_d = o['locale']) !== null && _d !== void 0 ? _d : '',
    };
}
export function listFiltersResponseToJson(m) {
    const o = {};
    if (m.paging !== undefined)
        o['paging'] = pagedResponseMetadataToJson(m.paging);
    if (m.filters !== undefined) {
        o['filters'] = m.filters.map(e => filterDefinitionToJson(e));
    }
    return o;
}
export function listFiltersResponseFromJson(o) {
    var _a;
    return {
        paging: o['paging'] ? pagedResponseMetadataFromJson(o['paging']) : undefined,
        filters: ((_a = o['filters']) !== null && _a !== void 0 ? _a : []).map(e => filterDefinitionFromJson(e)),
    };
}
export function listMultiLocationFiltersRequestToJson(m) {
    const o = {};
    if (m.namespaces !== undefined) {
        o['namespaces'] = m.namespaces.map(e => e);
    }
    if (m.paging !== undefined)
        o['paging'] = pagedRequestOptionsToJson(m.paging);
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.locale !== undefined)
        o['locale'] = m.locale;
    return o;
}
export function listMultiLocationFiltersRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespaces: ((_a = o['namespaces']) !== null && _a !== void 0 ? _a : []).map(e => e),
        paging: o['paging'] ? pagedRequestOptionsFromJson(o['paging']) : undefined,
        searchTerm: (_b = o['searchTerm']) !== null && _b !== void 0 ? _b : '',
        locale: (_c = o['locale']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listMultiLocationFiltersResponseToJson(m) {
    const o = {};
    if (m.paging !== undefined)
        o['paging'] = pagedResponseMetadataToJson(m.paging);
    if (m.filters !== undefined) {
        o['filters'] = m.filters.map(e => filterDefinitionToJson(e));
    }
    return o;
}
export function listMultiLocationFiltersResponseFromJson(o) {
    var _a;
    return {
        paging: o['paging'] ? pagedResponseMetadataFromJson(o['paging']) : undefined,
        filters: ((_a = o['filters']) !== null && _a !== void 0 ? _a : []).map(e => filterDefinitionFromJson(e)),
    };
}
export function createAssociationRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.association !== undefined)
        o['association'] = associationToJson(m.association);
    return o;
}
export function createAssociationRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        association: o['association'] ? associationFromJson(o['association']) : undefined,
    };
}
export function createAssociationResponseToJson(m) {
    const o = {};
    if (m.associationId !== undefined)
        o['associationId'] = m.associationId;
    return o;
}
export function createAssociationResponseFromJson(o) {
    var _a;
    return {
        associationId: (_a = o['associationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateAssociationRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.associationId !== undefined)
        o['associationId'] = m.associationId;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => tagToJson(e));
    }
    return o;
}
export function updateAssociationRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        associationId: (_b = o['associationId']) !== null && _b !== void 0 ? _b : '',
        tags: ((_c = o['tags']) !== null && _c !== void 0 ? _c : []).map(e => tagFromJson(e)),
    };
}
export function getMultiAssociationRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.associationIds !== undefined) {
        o['associationIds'] = m.associationIds.map(e => e);
    }
    return o;
}
export function getMultiAssociationRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        associationIds: ((_b = o['associationIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function getMultiAssociationResponseToJson(m) {
    const o = {};
    if (m.associations !== undefined) {
        o['associations'] = m.associations.map(e => associationToJson(e));
    }
    if (m.statusCode !== undefined) {
        o['statusCode'] = m.statusCode.map(e => e);
    }
    return o;
}
export function getMultiAssociationResponseFromJson(o) {
    var _a, _b;
    return {
        associations: ((_a = o['associations']) !== null && _a !== void 0 ? _a : []).map(e => associationFromJson(e)),
        statusCode: ((_b = o['statusCode']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function deleteAssociationRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.associationId !== undefined)
        o['associationId'] = m.associationId;
    return o;
}
export function deleteAssociationRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        associationId: (_b = o['associationId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function tagToJson(m) {
    const o = {};
    if (m.tagValue !== undefined)
        o['tagValue'] = m.tagValue;
    return o;
}
export function tagFromJson(o) {
    var _a;
    return {
        tagValue: (_a = o['tagValue']) !== null && _a !== void 0 ? _a : '',
    };
}
export function associationToJson(m) {
    const o = {};
    if (m.associationId !== undefined)
        o['associationId'] = m.associationId;
    if (m.associationType !== undefined)
        o['associationType'] = m.associationType;
    if (m.fromId !== undefined)
        o['fromId'] = m.fromId;
    if (m.toId !== undefined)
        o['toId'] = m.toId;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => tagToJson(e));
    }
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.fromCrmObjectSubtype !== undefined)
        o['fromCrmObjectSubtype'] = m.fromCrmObjectSubtype;
    if (m.toCrmObjectSubtype !== undefined)
        o['toCrmObjectSubtype'] = m.toCrmObjectSubtype;
    return o;
}
export function associationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        associationId: (_a = o['associationId']) !== null && _a !== void 0 ? _a : '',
        associationType: (_b = o['associationType']) !== null && _b !== void 0 ? _b : '',
        fromId: (_c = o['fromId']) !== null && _c !== void 0 ? _c : '',
        toId: (_d = o['toId']) !== null && _d !== void 0 ? _d : '',
        tags: ((_e = o['tags']) !== null && _e !== void 0 ? _e : []).map(e => tagFromJson(e)),
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        fromCrmObjectSubtype: (_f = o['fromCrmObjectSubtype']) !== null && _f !== void 0 ? _f : '',
        toCrmObjectSubtype: (_g = o['toCrmObjectSubtype']) !== null && _g !== void 0 ? _g : '',
    };
}
export function listAssociationsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.filtersV2 !== undefined)
        o['filtersV2'] = filterGroupToJson(m.filtersV2);
    return o;
}
export function listAssociationsRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        filtersV2: o['filtersV2'] ? filterGroupFromJson(o['filtersV2']) : undefined,
    };
}
export function listAssociationsResponseToJson(m) {
    const o = {};
    if (m.associations !== undefined) {
        o['associations'] = m.associations.map(e => associationToJson(e));
    }
    if (m.statusCode !== undefined) {
        o['statusCode'] = m.statusCode.map(e => e);
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listAssociationsResponseFromJson(o) {
    var _a, _b;
    return {
        associations: ((_a = o['associations']) !== null && _a !== void 0 ? _a : []).map(e => associationFromJson(e)),
        statusCode: ((_b = o['statusCode']) !== null && _b !== void 0 ? _b : []).map(e => e),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function listAssociationFieldOptionsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.associationType !== undefined)
        o['associationType'] = m.associationType;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    return o;
}
export function listAssociationFieldOptionsRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        associationType: (_b = o['associationType']) !== null && _b !== void 0 ? _b : '',
        fieldId: (_c = o['fieldId']) !== null && _c !== void 0 ? _c : '',
        pageSize: (_d = o['pageSize']) !== null && _d !== void 0 ? _d : 0,
        searchTerm: (_e = o['searchTerm']) !== null && _e !== void 0 ? _e : '',
    };
}
export function listAssociationFieldOptionsResponseToJson(m) {
    const o = {};
    if (m.options !== undefined) {
        o['options'] = m.options.map(e => e);
    }
    return o;
}
export function listAssociationFieldOptionsResponseFromJson(o) {
    var _a;
    return {
        options: ((_a = o['options']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function findAssociationsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.associationType !== undefined)
        o['associationType'] = m.associationType;
    if (m.fromIds !== undefined) {
        o['fromIds'] = m.fromIds.map(e => e);
    }
    if (m.toIds !== undefined) {
        o['toIds'] = m.toIds.map(e => e);
    }
    return o;
}
export function findAssociationsRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        associationType: (_b = o['associationType']) !== null && _b !== void 0 ? _b : '',
        fromIds: ((_c = o['fromIds']) !== null && _c !== void 0 ? _c : []).map(e => e),
        toIds: ((_d = o['toIds']) !== null && _d !== void 0 ? _d : []).map(e => e),
    };
}
export function findAssociationsResponseToJson(m) {
    const o = {};
    if (m.associations !== undefined) {
        o['associations'] = m.associations.map(e => associationToJson(e));
    }
    return o;
}
export function findAssociationsResponseFromJson(o) {
    var _a;
    return {
        associations: ((_a = o['associations']) !== null && _a !== void 0 ? _a : []).map(e => associationFromJson(e)),
    };
}
export function createLineItemRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.lineItem !== undefined)
        o['lineItem'] = lineItemToJson(m.lineItem);
    return o;
}
export function createLineItemRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        lineItem: o['lineItem'] ? lineItemFromJson(o['lineItem']) : undefined,
    };
}
export function createLineItemResponseToJson(m) {
    const o = {};
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    return o;
}
export function createLineItemResponseFromJson(o) {
    var _a;
    return {
        crmObjectId: (_a = o['crmObjectId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateLineItemRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.lineItem !== undefined)
        o['lineItem'] = lineItemToJson(m.lineItem);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateLineItemRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        lineItem: o['lineItem'] ? lineItemFromJson(o['lineItem']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function getMultiLineItemRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectIds !== undefined) {
        o['crmObjectIds'] = m.crmObjectIds.map(e => e);
    }
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function getMultiLineItemRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectIds: ((_b = o['crmObjectIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function getMultiLineItemResponseToJson(m) {
    const o = {};
    if (m.lineItems !== undefined) {
        o['lineItems'] = m.lineItems.map(e => lineItemToJson(e));
    }
    if (m.fieldSchemas !== undefined) {
        o['fieldSchemas'] = m.fieldSchemas.map(e => fieldSchemaToJson(e));
    }
    return o;
}
export function getMultiLineItemResponseFromJson(o) {
    var _a, _b;
    return {
        lineItems: ((_a = o['lineItems']) !== null && _a !== void 0 ? _a : []).map(e => lineItemFromJson(e)),
        fieldSchemas: ((_b = o['fieldSchemas']) !== null && _b !== void 0 ? _b : []).map(e => fieldSchemaFromJson(e)),
    };
}
export function deleteLineItemRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    return o;
}
export function deleteLineItemRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectId: (_b = o['crmObjectId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function restoreLineItemRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    return o;
}
export function restoreLineItemRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectId: (_b = o['crmObjectId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listLineItemsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.search !== undefined)
        o['search'] = crmObjectSearchToJson(m.search);
    if (m.sortBy !== undefined) {
        o['sortBy'] = m.sortBy.map(e => sortByToJson(e));
    }
    if (m.filters !== undefined)
        o['filters'] = filterGroupToJson(m.filters);
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    return o;
}
export function listLineItemsRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        search: o['search'] ? crmObjectSearchFromJson(o['search']) : undefined,
        sortBy: ((_b = o['sortBy']) !== null && _b !== void 0 ? _b : []).map(e => sortByFromJson(e)),
        filters: o['filters'] ? filterGroupFromJson(o['filters']) : undefined,
        crmObjectId: (_c = o['crmObjectId']) !== null && _c !== void 0 ? _c : '',
        crmObjectType: (_d = o['crmObjectType']) !== null && _d !== void 0 ? _d : '',
    };
}
export function listLineItemsResponseToJson(m) {
    const o = {};
    if (m.lineItems !== undefined) {
        o['lineItems'] = m.lineItems.map(e => lineItemToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listLineItemsResponseFromJson(o) {
    var _a;
    return {
        lineItems: ((_a = o['lineItems']) !== null && _a !== void 0 ? _a : []).map(e => lineItemFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function lineItemAssociationToJson(m) {
    const o = {};
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    return o;
}
export function lineItemAssociationFromJson(o) {
    var _a, _b, _c;
    return {
        crmObjectId: (_a = o['crmObjectId']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        tags: ((_c = o['tags']) !== null && _c !== void 0 ? _c : []).map(e => e),
    };
}
export function lineItemToJson(m) {
    const o = {};
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    if (m.externalId !== undefined)
        o['externalId'] = m.externalId;
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.groupId !== undefined)
        o['groupId'] = m.groupId;
    if (m.fields !== undefined) {
        o['fields'] = m.fields.map(e => fieldValueToJson(e));
    }
    if (m.associations !== undefined) {
        o['associations'] = m.associations.map(e => lineItemAssociationToJson(e));
    }
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function lineItemFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        crmObjectId: (_a = o['crmObjectId']) !== null && _a !== void 0 ? _a : '',
        externalId: (_b = o['externalId']) !== null && _b !== void 0 ? _b : '',
        ownerId: (_c = o['ownerId']) !== null && _c !== void 0 ? _c : '',
        groupId: (_d = o['groupId']) !== null && _d !== void 0 ? _d : '',
        fields: ((_e = o['fields']) !== null && _e !== void 0 ? _e : []).map(e => fieldValueFromJson(e)),
        associations: ((_f = o['associations']) !== null && _f !== void 0 ? _f : []).map(e => lineItemAssociationFromJson(e)),
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        namespace: (_g = o['namespace']) !== null && _g !== void 0 ? _g : '',
    };
}
export function listFileUploadsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    return o;
}
export function listFileUploadsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
    };
}
export function cSVSizeToJson(m) {
    const o = {};
    if (m.totalRows !== undefined)
        o['totalRows'] = m.totalRows;
    if (m.isEstimate !== undefined)
        o['isEstimate'] = m.isEstimate;
    return o;
}
export function cSVSizeFromJson(o) {
    var _a, _b;
    return {
        totalRows: (_a = o['totalRows']) !== null && _a !== void 0 ? _a : '',
        isEstimate: (_b = o['isEstimate']) !== null && _b !== void 0 ? _b : false,
    };
}
export function headerToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.sampleData !== undefined) {
        o['sampleData'] = m.sampleData.map(e => e);
    }
    return o;
}
export function headerFromJson(o) {
    var _a, _b;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        sampleData: ((_b = o['sampleData']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function cSVFileToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.filename !== undefined)
        o['filename'] = m.filename;
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.headers !== undefined) {
        o['headers'] = m.headers.map(e => headerToJson(e));
    }
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.size !== undefined)
        o['size'] = cSVSizeToJson(m.size);
    if (m.mappingSuggestions !== undefined) {
        o['mappingSuggestions'] = m.mappingSuggestions.map(e => cSVHeaderMappingToJson(e));
    }
    return o;
}
export function cSVFileFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        filename: (_b = o['filename']) !== null && _b !== void 0 ? _b : '',
        url: (_c = o['url']) !== null && _c !== void 0 ? _c : '',
        headers: ((_d = o['headers']) !== null && _d !== void 0 ? _d : []).map(e => headerFromJson(e)),
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        size: o['size'] ? cSVSizeFromJson(o['size']) : undefined,
        mappingSuggestions: ((_e = o['mappingSuggestions']) !== null && _e !== void 0 ? _e : []).map(e => cSVHeaderMappingFromJson(e)),
    };
}
export function listFileUploadsResponseToJson(m) {
    const o = {};
    if (m.files !== undefined) {
        o['files'] = m.files.map(e => cSVFileToJson(e));
    }
    return o;
}
export function listFileUploadsResponseFromJson(o) {
    var _a;
    return {
        files: ((_a = o['files']) !== null && _a !== void 0 ? _a : []).map(e => cSVFileFromJson(e)),
    };
}
export function getMultiFileUploadDataRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.filename !== undefined) {
        o['filename'] = m.filename.map(e => e);
    }
    return o;
}
export function getMultiFileUploadDataRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
        filename: ((_d = o['filename']) !== null && _d !== void 0 ? _d : []).map(e => e),
    };
}
export function getMultiFileUploadDataResponseToJson(m) {
    const o = {};
    if (m.files !== undefined) {
        o['files'] = m.files.map(e => cSVFileToJson(e));
    }
    return o;
}
export function getMultiFileUploadDataResponseFromJson(o) {
    var _a;
    return {
        files: ((_a = o['files']) !== null && _a !== void 0 ? _a : []).map(e => cSVFileFromJson(e)),
    };
}
export function cSVHeaderMappingToJson(m) {
    const o = {};
    if (m.headerName !== undefined)
        o['headerName'] = m.headerName;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    return o;
}
export function cSVHeaderMappingFromJson(o) {
    var _a, _b, _c, _d;
    return {
        headerName: (_a = o['headerName']) !== null && _a !== void 0 ? _a : '',
        fieldId: (_b = o['fieldId']) !== null && _b !== void 0 ? _b : '',
        crmObjectType: (_c = o['crmObjectType']) !== null && _c !== void 0 ? _c : '',
        crmObjectSubtype: (_d = o['crmObjectSubtype']) !== null && _d !== void 0 ? _d : '',
    };
}
export function multiObjectTypeImportFromFileRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.filename !== undefined)
        o['filename'] = m.filename;
    if (m.mappings !== undefined) {
        o['mappings'] = m.mappings.map(e => cSVHeaderMappingToJson(e));
    }
    if (m.duplicateHandlingType !== undefined)
        o['duplicateHandlingType'] = m.duplicateHandlingType;
    if (m.defaultFieldValues !== undefined) {
        o['defaultFieldValues'] = m.defaultFieldValues.map(e => fieldValueToJson(e));
    }
    return o;
}
export function multiObjectTypeImportFromFileRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        filename: (_b = o['filename']) !== null && _b !== void 0 ? _b : '',
        mappings: ((_c = o['mappings']) !== null && _c !== void 0 ? _c : []).map(e => cSVHeaderMappingFromJson(e)),
        duplicateHandlingType: (_d = o['duplicateHandlingType']) !== null && _d !== void 0 ? _d : 'DUPLICATE_HANDLING_TYPE_INVALID',
        defaultFieldValues: ((_e = o['defaultFieldValues']) !== null && _e !== void 0 ? _e : []).map(e => fieldValueFromJson(e)),
    };
}
export function multiObjectTypeImportFromFileResponseToJson(m) {
    const o = {};
    if (m.importId !== undefined)
        o['importId'] = m.importId;
    return o;
}
export function multiObjectTypeImportFromFileResponseFromJson(o) {
    var _a;
    return {
        importId: (_a = o['importId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function importRecordToJson(m) {
    const o = {};
    if (m.importId !== undefined)
        o['importId'] = m.importId;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.fileName !== undefined)
        o['fileName'] = m.fileName;
    if (m.mapping !== undefined) {
        o['mapping'] = m.mapping.map(e => cSVHeaderMappingToJson(e));
    }
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.itemsProcessed !== undefined)
        o['itemsProcessed'] = m.itemsProcessed;
    if (m.itemsError !== undefined)
        o['itemsError'] = m.itemsError;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.originalCsvUrl !== undefined)
        o['originalCsvUrl'] = m.originalCsvUrl;
    if (m.errorCsvUrl !== undefined)
        o['errorCsvUrl'] = m.errorCsvUrl;
    return o;
}
export function importRecordFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        importId: (_a = o['importId']) !== null && _a !== void 0 ? _a : '',
        namespace: (_b = o['namespace']) !== null && _b !== void 0 ? _b : '',
        fileName: (_c = o['fileName']) !== null && _c !== void 0 ? _c : '',
        mapping: ((_d = o['mapping']) !== null && _d !== void 0 ? _d : []).map(e => cSVHeaderMappingFromJson(e)),
        status: (_e = o['status']) !== null && _e !== void 0 ? _e : 'IMPORT_RECORD_STATUS_STARTED',
        itemsProcessed: (_f = o['itemsProcessed']) !== null && _f !== void 0 ? _f : 0,
        itemsError: (_g = o['itemsError']) !== null && _g !== void 0 ? _g : 0,
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        originalCsvUrl: (_h = o['originalCsvUrl']) !== null && _h !== void 0 ? _h : '',
        errorCsvUrl: (_j = o['errorCsvUrl']) !== null && _j !== void 0 ? _j : '',
    };
}
export function listImportRecordsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listImportRecordsRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listImportRecordsResponseToJson(m) {
    const o = {};
    if (m.importRecord !== undefined) {
        o['importRecord'] = m.importRecord.map(e => importRecordToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listImportRecordsResponseFromJson(o) {
    var _a;
    return {
        importRecord: ((_a = o['importRecord']) !== null && _a !== void 0 ? _a : []).map(e => importRecordFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function getMultiImportRecordRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.importIds !== undefined) {
        o['importIds'] = m.importIds.map(e => e);
    }
    return o;
}
export function getMultiImportRecordRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        importIds: ((_b = o['importIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function getMultiImportRecordResponseToJson(m) {
    const o = {};
    if (m.importRecords !== undefined) {
        o['importRecords'] = m.importRecords.map(e => importRecordToJson(e));
    }
    return o;
}
export function getMultiImportRecordResponseFromJson(o) {
    var _a;
    return {
        importRecords: ((_a = o['importRecords']) !== null && _a !== void 0 ? _a : []).map(e => importRecordFromJson(e)),
    };
}
export function reprocessImportRecordRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.importId !== undefined)
        o['importId'] = m.importId;
    if (m.duplicateHandlingType !== undefined)
        o['duplicateHandlingType'] = m.duplicateHandlingType;
    if (m.defaultFieldValues !== undefined) {
        o['defaultFieldValues'] = m.defaultFieldValues.map(e => fieldValueToJson(e));
    }
    return o;
}
export function reprocessImportRecordRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        importId: (_b = o['importId']) !== null && _b !== void 0 ? _b : '',
        duplicateHandlingType: (_c = o['duplicateHandlingType']) !== null && _c !== void 0 ? _c : 'DUPLICATE_HANDLING_TYPE_INVALID',
        defaultFieldValues: ((_d = o['defaultFieldValues']) !== null && _d !== void 0 ? _d : []).map(e => fieldValueFromJson(e)),
    };
}
export function listFieldGroupsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listFieldGroupsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listFieldGroupsResponseToJson(m) {
    const o = {};
    if (m.fieldGroups !== undefined) {
        o['fieldGroups'] = m.fieldGroups.map(e => fieldGroupToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listFieldGroupsResponseFromJson(o) {
    var _a;
    return {
        fieldGroups: ((_a = o['fieldGroups']) !== null && _a !== void 0 ? _a : []).map(e => fieldGroupFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function listMultiLocationFieldGroupsRequestToJson(m) {
    const o = {};
    if (m.namespaces !== undefined) {
        o['namespaces'] = m.namespaces.map(e => e);
    }
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listMultiLocationFieldGroupsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespaces: ((_a = o['namespaces']) !== null && _a !== void 0 ? _a : []).map(e => e),
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listMultiLocationFieldGroupsResponseToJson(m) {
    const o = {};
    if (m.fieldGroups !== undefined) {
        o['fieldGroups'] = m.fieldGroups.map(e => fieldGroupToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listMultiLocationFieldGroupsResponseFromJson(o) {
    var _a;
    return {
        fieldGroups: ((_a = o['fieldGroups']) !== null && _a !== void 0 ? _a : []).map(e => fieldGroupFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function fieldGroupToJson(m) {
    const o = {};
    if (m.fieldGroupId !== undefined)
        o['fieldGroupId'] = m.fieldGroupId;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.fieldIds !== undefined) {
        o['fieldIds'] = m.fieldIds.map(e => e);
    }
    return o;
}
export function fieldGroupFromJson(o) {
    var _a, _b, _c;
    return {
        fieldGroupId: (_a = o['fieldGroupId']) !== null && _a !== void 0 ? _a : '',
        description: (_b = o['description']) !== null && _b !== void 0 ? _b : '',
        fieldIds: ((_c = o['fieldIds']) !== null && _c !== void 0 ? _c : []).map(e => e),
    };
}
export function fieldLayoutConfigToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.fieldGroups !== undefined) {
        o['fieldGroups'] = m.fieldGroups.map(e => fieldGroupToJson(e));
    }
    if (m.unassignedSortOrder !== undefined)
        o['unassignedSortOrder'] = m.unassignedSortOrder;
    return o;
}
export function fieldLayoutConfigFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
        fieldGroups: ((_d = o['fieldGroups']) !== null && _d !== void 0 ? _d : []).map(e => fieldGroupFromJson(e)),
        unassignedSortOrder: (_e = o['unassignedSortOrder']) !== null && _e !== void 0 ? _e : '',
    };
}
export function getFieldLayoutRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    return o;
}
export function getFieldLayoutRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getFieldLayoutResponseToJson(m) {
    const o = {};
    if (m.fieldLayout !== undefined)
        o['fieldLayout'] = fieldLayoutConfigToJson(m.fieldLayout);
    return o;
}
export function getFieldLayoutResponseFromJson(o) {
    return {
        fieldLayout: o['fieldLayout'] ? fieldLayoutConfigFromJson(o['fieldLayout']) : undefined,
    };
}
export function upsertFieldLayoutRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.fieldLayout !== undefined)
        o['fieldLayout'] = fieldLayoutConfigToJson(m.fieldLayout);
    return o;
}
export function upsertFieldLayoutRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        fieldLayout: o['fieldLayout'] ? fieldLayoutConfigFromJson(o['fieldLayout']) : undefined,
    };
}
export function resetFieldLayoutRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    return o;
}
export function resetFieldLayoutRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listFieldLayoutsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listFieldLayoutsRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listFieldLayoutsResponseToJson(m) {
    const o = {};
    if (m.fieldLayouts !== undefined) {
        o['fieldLayouts'] = m.fieldLayouts.map(e => fieldLayoutConfigToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listFieldLayoutsResponseFromJson(o) {
    var _a;
    return {
        fieldLayouts: ((_a = o['fieldLayouts']) !== null && _a !== void 0 ? _a : []).map(e => fieldLayoutConfigFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function fieldExtensionToJson(m) {
    const o = {};
    if (m.extensionId !== undefined)
        o['extensionId'] = m.extensionId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    return o;
}
export function fieldExtensionFromJson(o) {
    var _a, _b, _c;
    return {
        extensionId: (_a = o['extensionId']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function createFieldExtensionRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.extension !== undefined)
        o['extension'] = fieldExtensionToJson(m.extension);
    return o;
}
export function createFieldExtensionRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        extension: o['extension'] ? fieldExtensionFromJson(o['extension']) : undefined,
    };
}
export function createFieldExtensionResponseToJson(m) {
    const o = {};
    if (m.extensionId !== undefined)
        o['extensionId'] = m.extensionId;
    return o;
}
export function createFieldExtensionResponseFromJson(o) {
    var _a;
    return {
        extensionId: (_a = o['extensionId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getMultiFieldExtensionRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.extensionIds !== undefined) {
        o['extensionIds'] = m.extensionIds.map(e => e);
    }
    return o;
}
export function getMultiFieldExtensionRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        extensionIds: ((_b = o['extensionIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function getMultiFieldExtensionResponseToJson(m) {
    const o = {};
    if (m.extensions !== undefined) {
        o['extensions'] = m.extensions.map(e => fieldExtensionToJson(e));
    }
    return o;
}
export function getMultiFieldExtensionResponseFromJson(o) {
    var _a;
    return {
        extensions: ((_a = o['extensions']) !== null && _a !== void 0 ? _a : []).map(e => fieldExtensionFromJson(e)),
    };
}
export function updateFieldExtensionRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.extension !== undefined)
        o['extension'] = fieldExtensionToJson(m.extension);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateFieldExtensionRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        extension: o['extension'] ? fieldExtensionFromJson(o['extension']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function deleteFieldExtensionRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.extensionId !== undefined)
        o['extensionId'] = m.extensionId;
    return o;
}
export function deleteFieldExtensionRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        extensionId: (_b = o['extensionId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function addFieldExtensionRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.extensionId !== undefined)
        o['extensionId'] = m.extensionId;
    return o;
}
export function addFieldExtensionRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        extensionId: (_b = o['extensionId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function removeFieldExtensionRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.extensionId !== undefined)
        o['extensionId'] = m.extensionId;
    return o;
}
export function removeFieldExtensionRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        extensionId: (_b = o['extensionId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listAddedExtensionsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listAddedExtensionsRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listAddedExtensionsResponseToJson(m) {
    const o = {};
    if (m.extensionIds !== undefined) {
        o['extensionIds'] = m.extensionIds.map(e => e);
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listAddedExtensionsResponseFromJson(o) {
    var _a;
    return {
        extensionIds: ((_a = o['extensionIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function getMultiAddedExtensionsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.extensionIds !== undefined) {
        o['extensionIds'] = m.extensionIds.map(e => e);
    }
    return o;
}
export function getMultiAddedExtensionsRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        extensionIds: ((_b = o['extensionIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function getMultiAddedExtensionsResponseToJson(m) {
    const o = {};
    if (m.extensionAddedIds !== undefined) {
        o['extensionAddedIds'] = m.extensionAddedIds.map(e => e);
    }
    return o;
}
export function getMultiAddedExtensionsResponseFromJson(o) {
    var _a;
    return {
        extensionAddedIds: ((_a = o['extensionAddedIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function parentNamespaceToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.parentNamespace !== undefined)
        o['parentNamespace'] = m.parentNamespace;
    return o;
}
export function parentNamespaceFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        parentNamespace: (_b = o['parentNamespace']) !== null && _b !== void 0 ? _b : '',
    };
}
export function createParentNamespaceRequestToJson(m) {
    const o = {};
    if (m.parentNamespace !== undefined)
        o['parentNamespace'] = parentNamespaceToJson(m.parentNamespace);
    return o;
}
export function createParentNamespaceRequestFromJson(o) {
    return {
        parentNamespace: o['parentNamespace'] ? parentNamespaceFromJson(o['parentNamespace']) : undefined,
    };
}
export function getMultiParentNamespaceRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined) {
        o['namespace'] = m.namespace.map(e => e);
    }
    return o;
}
export function getMultiParentNamespaceRequestFromJson(o) {
    var _a;
    return {
        namespace: ((_a = o['namespace']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function getMultiParentNamespaceResponseToJson(m) {
    const o = {};
    if (m.parentNamespace !== undefined) {
        o['parentNamespace'] = m.parentNamespace.map(e => parentNamespaceToJson(e));
    }
    return o;
}
export function getMultiParentNamespaceResponseFromJson(o) {
    var _a;
    return {
        parentNamespace: ((_a = o['parentNamespace']) !== null && _a !== void 0 ? _a : []).map(e => parentNamespaceFromJson(e)),
    };
}
export function deleteParentNamespaceRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function deleteParentNamespaceRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
    };
}
export function resolveNamespaceRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function resolveNamespaceRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
    };
}
export function resolveNamespaceResponseToJson(m) {
    const o = {};
    if (m.originalNamespace !== undefined)
        o['originalNamespace'] = m.originalNamespace;
    if (m.resolvedNamespace !== undefined)
        o['resolvedNamespace'] = m.resolvedNamespace;
    return o;
}
export function resolveNamespaceResponseFromJson(o) {
    var _a, _b;
    return {
        originalNamespace: (_a = o['originalNamespace']) !== null && _a !== void 0 ? _a : '',
        resolvedNamespace: (_b = o['resolvedNamespace']) !== null && _b !== void 0 ? _b : '',
    };
}
export function searchPITCrmObjectsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.objectType !== undefined)
        o['objectType'] = m.objectType;
    if (m.search !== undefined)
        o['search'] = crmObjectSearchToJson(m.search);
    if (m.sortBy !== undefined) {
        o['sortBy'] = m.sortBy.map(e => sortByToJson(e));
    }
    if (m.pitParams !== undefined)
        o['pitParams'] = crmSearchPITParamsToJson(m.pitParams);
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.filtersV3 !== undefined)
        o['filtersV3'] = filterGroupToJson(m.filtersV3);
    if (m.checkAccessOnly !== undefined)
        o['checkAccessOnly'] = m.checkAccessOnly;
    if (m.extraFieldId !== undefined) {
        o['extraFieldId'] = m.extraFieldId.map(e => e);
    }
    if (m.filterGroups !== undefined) {
        o['filterGroups'] = m.filterGroups.map(e => filterGroupToJson(e));
    }
    if (m.objectSubtype !== undefined)
        o['objectSubtype'] = m.objectSubtype;
    return o;
}
export function searchPITCrmObjectsRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        objectType: (_b = o['objectType']) !== null && _b !== void 0 ? _b : '',
        search: o['search'] ? crmObjectSearchFromJson(o['search']) : undefined,
        sortBy: ((_c = o['sortBy']) !== null && _c !== void 0 ? _c : []).map(e => sortByFromJson(e)),
        pitParams: o['pitParams'] ? crmSearchPITParamsFromJson(o['pitParams']) : undefined,
        pageSize: (_d = o['pageSize']) !== null && _d !== void 0 ? _d : 0,
        filtersV3: o['filtersV3'] ? filterGroupFromJson(o['filtersV3']) : undefined,
        checkAccessOnly: (_e = o['checkAccessOnly']) !== null && _e !== void 0 ? _e : false,
        extraFieldId: ((_f = o['extraFieldId']) !== null && _f !== void 0 ? _f : []).map(e => e),
        filterGroups: ((_g = o['filterGroups']) !== null && _g !== void 0 ? _g : []).map(e => filterGroupFromJson(e)),
        objectSubtype: (_h = o['objectSubtype']) !== null && _h !== void 0 ? _h : '',
    };
}
export function searchPITCrmObjectsResponseToJson(m) {
    const o = {};
    if (m.crmObjectIds !== undefined) {
        o['crmObjectIds'] = m.crmObjectIds.map(e => e);
    }
    if (m.pitParams !== undefined)
        o['pitParams'] = crmSearchPITParamsToJson(m.pitParams);
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    if (m.extraFields !== undefined) {
        o['extraFields'] = m.extraFields.map(e => crmPITExtraFieldsToJson(e));
    }
    return o;
}
export function searchPITCrmObjectsResponseFromJson(o) {
    var _a, _b, _c;
    return {
        crmObjectIds: ((_a = o['crmObjectIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        pitParams: o['pitParams'] ? crmSearchPITParamsFromJson(o['pitParams']) : undefined,
        hasMore: (_b = o['hasMore']) !== null && _b !== void 0 ? _b : false,
        extraFields: ((_c = o['extraFields']) !== null && _c !== void 0 ? _c : []).map(e => crmPITExtraFieldsFromJson(e)),
    };
}
export function crmSearchPITParamsToJson(m) {
    const o = {};
    if (m.pitId !== undefined)
        o['pitId'] = m.pitId;
    if (m.lastSortResponse !== undefined) {
        o['lastSortResponse'] = m.lastSortResponse.map(e => e);
    }
    if (m.tiebreaker !== undefined)
        o['tiebreaker'] = m.tiebreaker;
    return o;
}
export function crmSearchPITParamsFromJson(o) {
    var _a, _b, _c;
    return {
        pitId: (_a = o['pitId']) !== null && _a !== void 0 ? _a : '',
        lastSortResponse: ((_b = o['lastSortResponse']) !== null && _b !== void 0 ? _b : []).map(e => e),
        tiebreaker: (_c = o['tiebreaker']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function crmPITExtraFieldsToJson(m) {
    const o = {};
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    if (m.fields !== undefined) {
        o['fields'] = m.fields.map(e => fieldValueToJson(e));
    }
    return o;
}
export function crmPITExtraFieldsFromJson(o) {
    var _a, _b;
    return {
        crmObjectId: (_a = o['crmObjectId']) !== null && _a !== void 0 ? _a : '',
        fields: ((_b = o['fields']) !== null && _b !== void 0 ? _b : []).map(e => fieldValueFromJson(e)),
    };
}
export function getMultiCrmObjectChangeLogRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmChangelogIdentifiers !== undefined) {
        o['crmChangelogIdentifiers'] = m.crmChangelogIdentifiers.map(e => crmChangeLogIdentifiersToJson(e));
    }
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    return o;
}
export function getMultiCrmObjectChangeLogRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmChangelogIdentifiers: ((_b = o['crmChangelogIdentifiers']) !== null && _b !== void 0 ? _b : []).map(e => crmChangeLogIdentifiersFromJson(e)),
        crmObjectType: (_c = o['crmObjectType']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getMultiCrmObjectChangeLogResponseToJson(m) {
    const o = {};
    if (m.changeLogs !== undefined) {
        o['changeLogs'] = m.changeLogs.map(e => crmObjectChangeLogToJson(e));
    }
    return o;
}
export function getMultiCrmObjectChangeLogResponseFromJson(o) {
    var _a;
    return {
        changeLogs: ((_a = o['changeLogs']) !== null && _a !== void 0 ? _a : []).map(e => crmObjectChangeLogFromJson(e)),
    };
}
export function listChangeLogsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.sortBy !== undefined) {
        o['sortBy'] = m.sortBy.map(e => sortByToJson(e));
    }
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.filtersV2 !== undefined)
        o['filtersV2'] = filterGroupToJson(m.filtersV2);
    return o;
}
export function listChangeLogsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        sortBy: ((_b = o['sortBy']) !== null && _b !== void 0 ? _b : []).map(e => sortByFromJson(e)),
        crmObjectType: (_c = o['crmObjectType']) !== null && _c !== void 0 ? _c : '',
        filtersV2: o['filtersV2'] ? filterGroupFromJson(o['filtersV2']) : undefined,
    };
}
export function listChangeLogsResponseToJson(m) {
    const o = {};
    if (m.changeLogs !== undefined) {
        o['changeLogs'] = m.changeLogs.map(e => crmObjectChangeLogToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listChangeLogsResponseFromJson(o) {
    var _a;
    return {
        changeLogs: ((_a = o['changeLogs']) !== null && _a !== void 0 ? _a : []).map(e => crmObjectChangeLogFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function crmChangeLogIdentifiersToJson(m) {
    const o = {};
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    if (m.crmChangeId !== undefined)
        o['crmChangeId'] = m.crmChangeId;
    return o;
}
export function crmChangeLogIdentifiersFromJson(o) {
    var _a, _b;
    return {
        crmObjectId: (_a = o['crmObjectId']) !== null && _a !== void 0 ? _a : '',
        crmChangeId: (_b = o['crmChangeId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function crmObjectChangeLogToJson(m) {
    const o = {};
    if (m.crmChangeId !== undefined)
        o['crmChangeId'] = m.crmChangeId;
    if (m.crmChangeSubtype !== undefined)
        o['crmChangeSubtype'] = m.crmChangeSubtype;
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    if (m.externalId !== undefined)
        o['externalId'] = m.externalId;
    if (m.createdByUserId !== undefined)
        o['createdByUserId'] = m.createdByUserId;
    if (m.fields !== undefined) {
        o['fields'] = m.fields.map(e => fieldValueToJson(e));
    }
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.updatedByUserId !== undefined)
        o['updatedByUserId'] = m.updatedByUserId;
    return o;
}
export function crmObjectChangeLogFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        crmChangeId: (_a = o['crmChangeId']) !== null && _a !== void 0 ? _a : '',
        crmChangeSubtype: (_b = o['crmChangeSubtype']) !== null && _b !== void 0 ? _b : '',
        crmObjectId: (_c = o['crmObjectId']) !== null && _c !== void 0 ? _c : '',
        externalId: (_d = o['externalId']) !== null && _d !== void 0 ? _d : '',
        createdByUserId: (_e = o['createdByUserId']) !== null && _e !== void 0 ? _e : '',
        fields: ((_f = o['fields']) !== null && _f !== void 0 ? _f : []).map(e => fieldValueFromJson(e)),
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updatedByUserId: (_g = o['updatedByUserId']) !== null && _g !== void 0 ? _g : '',
    };
}
export function scoringObjectRuleToJson(m) {
    const o = {};
    if (m.filter !== undefined)
        o['filter'] = filterToJson(m.filter);
    return o;
}
export function scoringObjectRuleFromJson(o) {
    return {
        filter: o['filter'] ? filterFromJson(o['filter']) : undefined,
    };
}
export function scoringObjectRuleValueToJson(m) {
    const o = {};
    if (m.value !== undefined) {
        if (m.value.type === 'boolean') {
            o['boolean'] = m.value.boolean;
        }
        if (m.value.type === 'integer') {
            o['integer'] = m.value.integer;
        }
        if (m.value.type === 'float') {
            o['float'] = m.value.float;
        }
        if (m.value.type === 'string') {
            o['string'] = m.value.string;
        }
        if (m.value.type === 'date') {
            o['date'] = m.value.date.toISOString();
        }
    }
    else {
        if (m.boolean !== undefined)
            o['boolean'] = m.boolean;
        if (m.integer !== undefined)
            o['integer'] = m.integer;
        if (m.float !== undefined)
            o['float'] = m.float;
        if (m.string !== undefined)
            o['string'] = m.string;
        if (m.date !== undefined)
            o['date'] = m.date.toISOString();
    }
    return o;
}
export function scoringObjectRuleValueFromJson(o) {
    return {
        value: (() => {
            if (o['boolean'] !== undefined)
                return { type: 'boolean', boolean: o['boolean'] };
            if (o['integer'] !== undefined)
                return { type: 'integer', integer: o['integer'] };
            if (o['float'] !== undefined)
                return { type: 'float', float: o['float'] };
            if (o['string'] !== undefined)
                return { type: 'string', string: o['string'] };
            if (o['date'] !== undefined)
                return { type: 'date', date: o['date'] ? new Date(o['date']) : undefined };
            return undefined;
        })(),
        boolean: o['boolean'] !== undefined ? o['boolean'] : undefined,
        integer: o['integer'] !== undefined ? o['integer'] : undefined,
        float: o['float'] !== undefined ? o['float'] : undefined,
        string: o['string'] !== undefined ? o['string'] : undefined,
        date: o['date'] !== undefined ? o['date'] ? new Date(o['date']) : undefined : undefined,
    };
}
export function scoringRuleToJson(m) {
    const o = {};
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.objectRules !== undefined) {
        o['objectRules'] = m.objectRules.map(e => scoringObjectRuleToJson(e));
    }
    return o;
}
export function scoringRuleFromJson(o) {
    var _a, _b;
    return {
        crmObjectType: (_a = o['crmObjectType']) !== null && _a !== void 0 ? _a : '',
        objectRules: ((_b = o['objectRules']) !== null && _b !== void 0 ? _b : []).map(e => scoringObjectRuleFromJson(e)),
    };
}
export function scoringDefinitionToJson(m) {
    const o = {};
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.label !== undefined)
        o['label'] = m.label;
    if (m.scoringRules !== undefined) {
        o['scoringRules'] = m.scoringRules.map(e => scoringRuleToJson(e));
    }
    if (m.contribution !== undefined)
        o['contribution'] = m.contribution;
    if (m.scoringDefinitionId !== undefined)
        o['scoringDefinitionId'] = m.scoringDefinitionId;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    return o;
}
export function scoringDefinitionFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        crmObjectType: (_a = o['crmObjectType']) !== null && _a !== void 0 ? _a : '',
        label: (_b = o['label']) !== null && _b !== void 0 ? _b : '',
        scoringRules: ((_c = o['scoringRules']) !== null && _c !== void 0 ? _c : []).map(e => scoringRuleFromJson(e)),
        contribution: (_d = o['contribution']) !== null && _d !== void 0 ? _d : 0,
        scoringDefinitionId: (_e = o['scoringDefinitionId']) !== null && _e !== void 0 ? _e : '',
        fieldId: (_f = o['fieldId']) !== null && _f !== void 0 ? _f : '',
    };
}
export function createScoringDefinitionRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.scoringDefinition !== undefined)
        o['scoringDefinition'] = scoringDefinitionToJson(m.scoringDefinition);
    return o;
}
export function createScoringDefinitionRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        scoringDefinition: o['scoringDefinition'] ? scoringDefinitionFromJson(o['scoringDefinition']) : undefined,
    };
}
export function createScoringDefinitionResponseToJson(m) {
    const o = {};
    if (m.scoringDefinitionId !== undefined)
        o['scoringDefinitionId'] = m.scoringDefinitionId;
    return o;
}
export function createScoringDefinitionResponseFromJson(o) {
    var _a;
    return {
        scoringDefinitionId: (_a = o['scoringDefinitionId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getMultiScoringDefinitionRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.scoringDefinitionIds !== undefined) {
        o['scoringDefinitionIds'] = m.scoringDefinitionIds.map(e => e);
    }
    return o;
}
export function getMultiScoringDefinitionRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        scoringDefinitionIds: ((_b = o['scoringDefinitionIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function getMultiScoringDefinitionResponseToJson(m) {
    const o = {};
    if (m.scoringDefinitions !== undefined) {
        o['scoringDefinitions'] = m.scoringDefinitions.map(e => scoringDefinitionToJson(e));
    }
    return o;
}
export function getMultiScoringDefinitionResponseFromJson(o) {
    var _a;
    return {
        scoringDefinitions: ((_a = o['scoringDefinitions']) !== null && _a !== void 0 ? _a : []).map(e => scoringDefinitionFromJson(e)),
    };
}
export function deleteScoringDefinitionRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.scoringDefinitionId !== undefined)
        o['scoringDefinitionId'] = m.scoringDefinitionId;
    return o;
}
export function deleteScoringDefinitionRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        scoringDefinitionId: (_b = o['scoringDefinitionId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listScoringDefinitionsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    return o;
}
export function listScoringDefinitionsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        fieldId: (_c = o['fieldId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listScoringDefinitionsResponseToJson(m) {
    const o = {};
    if (m.scoringDefinitions !== undefined) {
        o['scoringDefinitions'] = m.scoringDefinitions.map(e => scoringDefinitionToJson(e));
    }
    return o;
}
export function listScoringDefinitionsResponseFromJson(o) {
    var _a;
    return {
        scoringDefinitions: ((_a = o['scoringDefinitions']) !== null && _a !== void 0 ? _a : []).map(e => scoringDefinitionFromJson(e)),
    };
}
export function setScoringDefinitionsForFieldIDRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    if (m.scoringDefinitions !== undefined) {
        o['scoringDefinitions'] = m.scoringDefinitions.map(e => scoringDefinitionToJson(e));
    }
    return o;
}
export function setScoringDefinitionsForFieldIDRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        fieldId: (_b = o['fieldId']) !== null && _b !== void 0 ? _b : '',
        scoringDefinitions: ((_c = o['scoringDefinitions']) !== null && _c !== void 0 ? _c : []).map(e => scoringDefinitionFromJson(e)),
    };
}
export function scoringIdentifierToJson(m) {
    const o = {};
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.label !== undefined)
        o['label'] = m.label;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    return o;
}
export function scoringIdentifierFromJson(o) {
    var _a, _b, _c, _d;
    return {
        crmObjectId: (_a = o['crmObjectId']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        label: (_c = o['label']) !== null && _c !== void 0 ? _c : '',
        fieldId: (_d = o['fieldId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function getScoreRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.scoringIdentifier !== undefined)
        o['scoringIdentifier'] = scoringIdentifierToJson(m.scoringIdentifier);
    return o;
}
export function getScoreRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        scoringIdentifier: o['scoringIdentifier'] ? scoringIdentifierFromJson(o['scoringIdentifier']) : undefined,
    };
}
export function getScoreResponseToJson(m) {
    const o = {};
    if (m.score !== undefined)
        o['score'] = m.score;
    return o;
}
export function getScoreResponseFromJson(o) {
    var _a;
    return {
        score: (_a = o['score']) !== null && _a !== void 0 ? _a : 0,
    };
}
export function stageToJson(m) {
    const o = {};
    if (m.stageId !== undefined)
        o['stageId'] = m.stageId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.filterGroup !== undefined)
        o['filterGroup'] = filterGroupToJson(m.filterGroup);
    if (m.mutations !== undefined) {
        o['mutations'] = m.mutations.map(e => fieldValueToJson(e));
    }
    return o;
}
export function stageFromJson(o) {
    var _a, _b, _c;
    return {
        stageId: (_a = o['stageId']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        filterGroup: o['filterGroup'] ? filterGroupFromJson(o['filterGroup']) : undefined,
        mutations: ((_c = o['mutations']) !== null && _c !== void 0 ? _c : []).map(e => fieldValueFromJson(e)),
    };
}
export function pipelineToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.pipelineId !== undefined)
        o['pipelineId'] = m.pipelineId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.objectType !== undefined)
        o['objectType'] = m.objectType;
    if (m.stages !== undefined) {
        o['stages'] = m.stages.map(e => stageToJson(e));
    }
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    return o;
}
export function pipelineFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        pipelineId: (_b = o['pipelineId']) !== null && _b !== void 0 ? _b : '',
        name: (_c = o['name']) !== null && _c !== void 0 ? _c : '',
        objectType: (_d = o['objectType']) !== null && _d !== void 0 ? _d : '',
        stages: ((_e = o['stages']) !== null && _e !== void 0 ? _e : []).map(e => stageFromJson(e)),
        crmObjectSubtype: (_f = o['crmObjectSubtype']) !== null && _f !== void 0 ? _f : '',
    };
}
export function createPipelineRequestToJson(m) {
    const o = {};
    if (m.pipeline !== undefined)
        o['pipeline'] = pipelineToJson(m.pipeline);
    return o;
}
export function createPipelineRequestFromJson(o) {
    return {
        pipeline: o['pipeline'] ? pipelineFromJson(o['pipeline']) : undefined,
    };
}
export function createPipelineResponseToJson(m) {
    const o = {};
    if (m.pipelineId !== undefined)
        o['pipelineId'] = m.pipelineId;
    return o;
}
export function createPipelineResponseFromJson(o) {
    var _a;
    return {
        pipelineId: (_a = o['pipelineId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getMultiPipelineRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.pipelineIds !== undefined) {
        o['pipelineIds'] = m.pipelineIds.map(e => e);
    }
    return o;
}
export function getMultiPipelineRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        pipelineIds: ((_b = o['pipelineIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function getMultiPipelineResponseToJson(m) {
    const o = {};
    if (m.pipelines !== undefined) {
        o['pipelines'] = m.pipelines.map(e => pipelineToJson(e));
    }
    return o;
}
export function getMultiPipelineResponseFromJson(o) {
    var _a;
    return {
        pipelines: ((_a = o['pipelines']) !== null && _a !== void 0 ? _a : []).map(e => pipelineFromJson(e)),
    };
}
export function updatePipelineRequestToJson(m) {
    const o = {};
    if (m.pipeline !== undefined)
        o['pipeline'] = pipelineToJson(m.pipeline);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updatePipelineRequestFromJson(o) {
    return {
        pipeline: o['pipeline'] ? pipelineFromJson(o['pipeline']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function deletePipelineRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.pipelineId !== undefined)
        o['pipelineId'] = m.pipelineId;
    return o;
}
export function deletePipelineRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        pipelineId: (_b = o['pipelineId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listOptionsToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.objectType !== undefined)
        o['objectType'] = m.objectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    return o;
}
export function listOptionsFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        objectType: (_b = o['objectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listPipelinesRequestToJson(m) {
    const o = {};
    if (m.listOptions !== undefined)
        o['listOptions'] = listOptionsToJson(m.listOptions);
    return o;
}
export function listPipelinesRequestFromJson(o) {
    return {
        listOptions: o['listOptions'] ? listOptionsFromJson(o['listOptions']) : undefined,
    };
}
export function listPipelinesResponseToJson(m) {
    const o = {};
    if (m.pipelines !== undefined) {
        o['pipelines'] = m.pipelines.map(e => pipelineToJson(e));
    }
    return o;
}
export function listPipelinesResponseFromJson(o) {
    var _a;
    return {
        pipelines: ((_a = o['pipelines']) !== null && _a !== void 0 ? _a : []).map(e => pipelineFromJson(e)),
    };
}
export function customObjectTypeToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.customObjectTypeId !== undefined)
        o['customObjectTypeId'] = m.customObjectTypeId;
    if (m.singularObjectName !== undefined)
        o['singularObjectName'] = m.singularObjectName;
    if (m.pluralObjectName !== undefined)
        o['pluralObjectName'] = m.pluralObjectName;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    return o;
}
export function customObjectTypeFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        customObjectTypeId: (_b = o['customObjectTypeId']) !== null && _b !== void 0 ? _b : '',
        singularObjectName: (_c = o['singularObjectName']) !== null && _c !== void 0 ? _c : '',
        pluralObjectName: (_d = o['pluralObjectName']) !== null && _d !== void 0 ? _d : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function createCustomObjectTypeRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.customObjectType !== undefined)
        o['customObjectType'] = customObjectTypeToJson(m.customObjectType);
    return o;
}
export function createCustomObjectTypeRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        customObjectType: o['customObjectType'] ? customObjectTypeFromJson(o['customObjectType']) : undefined,
    };
}
export function createCustomObjectTypeResponseToJson(m) {
    const o = {};
    if (m.customObjectTypeId !== undefined)
        o['customObjectTypeId'] = m.customObjectTypeId;
    return o;
}
export function createCustomObjectTypeResponseFromJson(o) {
    var _a;
    return {
        customObjectTypeId: (_a = o['customObjectTypeId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getMultiCustomObjectTypeRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.customObjectTypeIds !== undefined) {
        o['customObjectTypeIds'] = m.customObjectTypeIds.map(e => e);
    }
    if (m.includeDeleted !== undefined)
        o['includeDeleted'] = m.includeDeleted;
    return o;
}
export function getMultiCustomObjectTypeRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        customObjectTypeIds: ((_b = o['customObjectTypeIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
        includeDeleted: (_c = o['includeDeleted']) !== null && _c !== void 0 ? _c : false,
    };
}
export function getMultiCustomObjectTypeResponseToJson(m) {
    const o = {};
    if (m.customObjectTypes !== undefined) {
        o['customObjectTypes'] = m.customObjectTypes.map(e => customObjectTypeToJson(e));
    }
    return o;
}
export function getMultiCustomObjectTypeResponseFromJson(o) {
    var _a;
    return {
        customObjectTypes: ((_a = o['customObjectTypes']) !== null && _a !== void 0 ? _a : []).map(e => customObjectTypeFromJson(e)),
    };
}
export function updateCustomObjectTypeRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.customObjectType !== undefined)
        o['customObjectType'] = customObjectTypeToJson(m.customObjectType);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateCustomObjectTypeRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        customObjectType: o['customObjectType'] ? customObjectTypeFromJson(o['customObjectType']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function deleteCustomObjectTypeRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.customObjectTypeId !== undefined)
        o['customObjectTypeId'] = m.customObjectTypeId;
    return o;
}
export function deleteCustomObjectTypeRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        customObjectTypeId: (_b = o['customObjectTypeId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listCustomObjectTypesRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function listCustomObjectTypesRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listCustomObjectTypesResponseToJson(m) {
    const o = {};
    if (m.customObjectTypes !== undefined) {
        o['customObjectTypes'] = m.customObjectTypes.map(e => customObjectTypeToJson(e));
    }
    return o;
}
export function listCustomObjectTypesResponseFromJson(o) {
    var _a;
    return {
        customObjectTypes: ((_a = o['customObjectTypes']) !== null && _a !== void 0 ? _a : []).map(e => customObjectTypeFromJson(e)),
    };
}
export function viewConfigurationToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.viewConfigurationId !== undefined)
        o['viewConfigurationId'] = m.viewConfigurationId;
    if (m.viewId !== undefined)
        o['viewId'] = m.viewId;
    if (m.componentId !== undefined)
        o['componentId'] = m.componentId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.enabled !== undefined)
        o['enabled'] = m.enabled;
    if (m.identifier !== undefined)
        o['identifier'] = m.identifier;
    if (m.isOverride !== undefined)
        o['isOverride'] = m.isOverride;
    return o;
}
export function viewConfigurationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        viewConfigurationId: (_b = o['viewConfigurationId']) !== null && _b !== void 0 ? _b : '',
        viewId: (_c = o['viewId']) !== null && _c !== void 0 ? _c : '',
        componentId: (_d = o['componentId']) !== null && _d !== void 0 ? _d : '',
        name: (_e = o['name']) !== null && _e !== void 0 ? _e : '',
        enabled: (_f = o['enabled']) !== null && _f !== void 0 ? _f : false,
        identifier: (_g = o['identifier']) !== null && _g !== void 0 ? _g : '',
        isOverride: (_h = o['isOverride']) !== null && _h !== void 0 ? _h : false,
    };
}
export function viewToJson(m) {
    const o = {};
    if (m.viewId !== undefined)
        o['viewId'] = m.viewId;
    if (m.componentId !== undefined)
        o['componentId'] = m.componentId;
    if (m.filters !== undefined)
        o['filters'] = m.filters;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function viewFromJson(o) {
    var _a, _b, _c, _d;
    return {
        viewId: (_a = o['viewId']) !== null && _a !== void 0 ? _a : '',
        componentId: (_b = o['componentId']) !== null && _b !== void 0 ? _b : '',
        filters: (_c = o['filters']) !== null && _c !== void 0 ? _c : '',
        namespace: (_d = o['namespace']) !== null && _d !== void 0 ? _d : '',
    };
}
export function getMultiViewRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.viewIds !== undefined) {
        o['viewIds'] = m.viewIds.map(e => e);
    }
    return o;
}
export function getMultiViewRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        viewIds: ((_b = o['viewIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function getMultiViewResponseToJson(m) {
    const o = {};
    if (m.views !== undefined) {
        o['views'] = m.views.map(e => viewToJson(e));
    }
    return o;
}
export function getMultiViewResponseFromJson(o) {
    var _a;
    return {
        views: ((_a = o['views']) !== null && _a !== void 0 ? _a : []).map(e => viewFromJson(e)),
    };
}
export function createViewConfigurationRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.componentId !== undefined)
        o['componentId'] = m.componentId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.enabled !== undefined)
        o['enabled'] = m.enabled;
    if (m.identifier !== undefined)
        o['identifier'] = m.identifier;
    if (m.filters !== undefined)
        o['filters'] = m.filters;
    return o;
}
export function createViewConfigurationRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        componentId: (_b = o['componentId']) !== null && _b !== void 0 ? _b : '',
        name: (_c = o['name']) !== null && _c !== void 0 ? _c : '',
        enabled: (_d = o['enabled']) !== null && _d !== void 0 ? _d : false,
        identifier: (_e = o['identifier']) !== null && _e !== void 0 ? _e : '',
        filters: (_f = o['filters']) !== null && _f !== void 0 ? _f : '',
    };
}
export function createViewConfigurationResponseToJson(m) {
    const o = {};
    if (m.viewConfigurationId !== undefined)
        o['viewConfigurationId'] = m.viewConfigurationId;
    return o;
}
export function createViewConfigurationResponseFromJson(o) {
    var _a;
    return {
        viewConfigurationId: (_a = o['viewConfigurationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getMultiViewConfigurationRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.viewConfigurationIds !== undefined) {
        o['viewConfigurationIds'] = m.viewConfigurationIds.map(e => e);
    }
    if (m.identifier !== undefined)
        o['identifier'] = m.identifier;
    return o;
}
export function getMultiViewConfigurationRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        viewConfigurationIds: ((_b = o['viewConfigurationIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
        identifier: (_c = o['identifier']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getMultiViewConfigurationResponseToJson(m) {
    const o = {};
    if (m.viewConfigurations !== undefined) {
        o['viewConfigurations'] = m.viewConfigurations.map(e => viewConfigurationToJson(e));
    }
    return o;
}
export function getMultiViewConfigurationResponseFromJson(o) {
    var _a;
    return {
        viewConfigurations: ((_a = o['viewConfigurations']) !== null && _a !== void 0 ? _a : []).map(e => viewConfigurationFromJson(e)),
    };
}
export function deleteViewConfigurationRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.viewConfigurationId !== undefined)
        o['viewConfigurationId'] = m.viewConfigurationId;
    if (m.identifier !== undefined)
        o['identifier'] = m.identifier;
    return o;
}
export function deleteViewConfigurationRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        viewConfigurationId: (_b = o['viewConfigurationId']) !== null && _b !== void 0 ? _b : '',
        identifier: (_c = o['identifier']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listViewConfigurationOptionsToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.identifier !== undefined)
        o['identifier'] = m.identifier;
    if (m.componentIds !== undefined) {
        o['componentIds'] = m.componentIds.map(e => e);
    }
    return o;
}
export function listViewConfigurationOptionsFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        identifier: (_b = o['identifier']) !== null && _b !== void 0 ? _b : '',
        componentIds: ((_c = o['componentIds']) !== null && _c !== void 0 ? _c : []).map(e => e),
    };
}
export function listViewConfigurationsRequestToJson(m) {
    const o = {};
    if (m.listOptions !== undefined)
        o['listOptions'] = listViewConfigurationOptionsToJson(m.listOptions);
    return o;
}
export function listViewConfigurationsRequestFromJson(o) {
    return {
        listOptions: o['listOptions'] ? listViewConfigurationOptionsFromJson(o['listOptions']) : undefined,
    };
}
export function listViewConfigurationsResponseToJson(m) {
    const o = {};
    if (m.viewConfigurations !== undefined) {
        o['viewConfigurations'] = m.viewConfigurations.map(e => viewConfigurationToJson(e));
    }
    return o;
}
export function listViewConfigurationsResponseFromJson(o) {
    var _a;
    return {
        viewConfigurations: ((_a = o['viewConfigurations']) !== null && _a !== void 0 ? _a : []).map(e => viewConfigurationFromJson(e)),
    };
}
export function updateViewConfigurationRequestToJson(m) {
    const o = {};
    if (m.viewConfigurationId !== undefined)
        o['viewConfigurationId'] = m.viewConfigurationId;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.componentId !== undefined)
        o['componentId'] = m.componentId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.enabled !== undefined)
        o['enabled'] = m.enabled;
    if (m.filters !== undefined)
        o['filters'] = m.filters;
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    if (m.identifier !== undefined)
        o['identifier'] = m.identifier;
    return o;
}
export function updateViewConfigurationRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        viewConfigurationId: (_a = o['viewConfigurationId']) !== null && _a !== void 0 ? _a : '',
        namespace: (_b = o['namespace']) !== null && _b !== void 0 ? _b : '',
        componentId: (_c = o['componentId']) !== null && _c !== void 0 ? _c : '',
        name: (_d = o['name']) !== null && _d !== void 0 ? _d : '',
        enabled: (_e = o['enabled']) !== null && _e !== void 0 ? _e : false,
        filters: (_f = o['filters']) !== null && _f !== void 0 ? _f : '',
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
        identifier: (_g = o['identifier']) !== null && _g !== void 0 ? _g : '',
    };
}
export function getComponentIdRequestToJson(m) {
    const o = {};
    if (m.app !== undefined)
        o['app'] = m.app;
    if (m.objectType !== undefined)
        o['objectType'] = m.objectType;
    if (m.subtype !== undefined)
        o['subtype'] = m.subtype;
    if (m.context !== undefined)
        o['context'] = m.context;
    return o;
}
export function getComponentIdRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        app: (_a = o['app']) !== null && _a !== void 0 ? _a : 'APP_UNSPECIFIED',
        objectType: (_b = o['objectType']) !== null && _b !== void 0 ? _b : '',
        subtype: (_c = o['subtype']) !== null && _c !== void 0 ? _c : '',
        context: (_d = o['context']) !== null && _d !== void 0 ? _d : 'CONTEXT_UNSPECIFIED',
    };
}
export function getComponentIdResponseToJson(m) {
    const o = {};
    if (m.componentId !== undefined)
        o['componentId'] = m.componentId;
    return o;
}
export function getComponentIdResponseFromJson(o) {
    var _a;
    return {
        componentId: (_a = o['componentId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function createViewConfigurationOverrideRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.identifier !== undefined)
        o['identifier'] = m.identifier;
    if (m.componentId !== undefined)
        o['componentId'] = m.componentId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.enabled !== undefined)
        o['enabled'] = m.enabled;
    if (m.viewConfigurationId !== undefined)
        o['viewConfigurationId'] = m.viewConfigurationId;
    if (m.namespaceOverride !== undefined)
        o['namespaceOverride'] = m.namespaceOverride;
    if (m.identifierOverride !== undefined)
        o['identifierOverride'] = m.identifierOverride;
    return o;
}
export function createViewConfigurationOverrideRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        identifier: (_b = o['identifier']) !== null && _b !== void 0 ? _b : '',
        componentId: (_c = o['componentId']) !== null && _c !== void 0 ? _c : '',
        name: (_d = o['name']) !== null && _d !== void 0 ? _d : '',
        enabled: (_e = o['enabled']) !== null && _e !== void 0 ? _e : false,
        viewConfigurationId: (_f = o['viewConfigurationId']) !== null && _f !== void 0 ? _f : '',
        namespaceOverride: (_g = o['namespaceOverride']) !== null && _g !== void 0 ? _g : '',
        identifierOverride: (_h = o['identifierOverride']) !== null && _h !== void 0 ? _h : '',
    };
}
export function createViewConfigurationOverrideResponseToJson(m) {
    const o = {};
    if (m.viewConfigurationId !== undefined)
        o['viewConfigurationId'] = m.viewConfigurationId;
    return o;
}
export function createViewConfigurationOverrideResponseFromJson(o) {
    var _a;
    return {
        viewConfigurationId: (_a = o['viewConfigurationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function crmExportObjectsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.objectType !== undefined)
        o['objectType'] = m.objectType;
    if (m.search !== undefined)
        o['search'] = crmObjectSearchToJson(m.search);
    if (m.filters !== undefined)
        o['filters'] = filterGroupToJson(m.filters);
    return o;
}
export function crmExportObjectsRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        objectType: (_b = o['objectType']) !== null && _b !== void 0 ? _b : '',
        search: o['search'] ? crmObjectSearchFromJson(o['search']) : undefined,
        filters: o['filters'] ? filterGroupFromJson(o['filters']) : undefined,
    };
}
export function queryObjectRefToJson(m) {
    const o = {};
    if (m.objectType !== undefined)
        o['objectType'] = m.objectType;
    if (m.customObjectTypeId !== undefined)
        o['customObjectTypeId'] = m.customObjectTypeId;
    if (m.alias !== undefined)
        o['alias'] = m.alias;
    return o;
}
export function queryObjectRefFromJson(o) {
    var _a, _b, _c;
    return {
        objectType: (_a = o['objectType']) !== null && _a !== void 0 ? _a : '',
        customObjectTypeId: (_b = o['customObjectTypeId']) !== null && _b !== void 0 ? _b : '',
        alias: (_c = o['alias']) !== null && _c !== void 0 ? _c : '',
    };
}
export function queryFieldRefToJson(m) {
    const o = {};
    if (m.object !== undefined)
        o['object'] = m.object;
    if (m.ref !== undefined) {
        if (m.ref.type === 'fieldId') {
            o['fieldId'] = m.ref.fieldId;
        }
        if (m.ref.type === 'externalId') {
            o['externalId'] = m.ref.externalId;
        }
        if (m.ref.type === 'name') {
            o['name'] = m.ref.name;
        }
    }
    else {
        if (m.fieldId !== undefined)
            o['fieldId'] = m.fieldId;
        if (m.externalId !== undefined)
            o['externalId'] = m.externalId;
        if (m.name !== undefined)
            o['name'] = m.name;
    }
    return o;
}
export function queryFieldRefFromJson(o) {
    var _a;
    return {
        object: (_a = o['object']) !== null && _a !== void 0 ? _a : '',
        ref: (() => {
            if (o['fieldId'] !== undefined)
                return { type: 'fieldId', fieldId: o['fieldId'] };
            if (o['externalId'] !== undefined)
                return { type: 'externalId', externalId: o['externalId'] };
            if (o['name'] !== undefined)
                return { type: 'name', name: o['name'] };
            return undefined;
        })(),
        fieldId: o['fieldId'] !== undefined ? o['fieldId'] : undefined,
        externalId: o['externalId'] !== undefined ? o['externalId'] : undefined,
        name: o['name'] !== undefined ? o['name'] : undefined,
    };
}
export function querySortToJson(m) {
    const o = {};
    if (m.field !== undefined)
        o['field'] = queryFieldRefToJson(m.field);
    if (m.descending !== undefined)
        o['descending'] = m.descending;
    return o;
}
export function querySortFromJson(o) {
    var _a;
    return {
        field: o['field'] ? queryFieldRefFromJson(o['field']) : undefined,
        descending: (_a = o['descending']) !== null && _a !== void 0 ? _a : false,
    };
}
export function queryAggregationToJson(m) {
    const o = {};
    if (m.op !== undefined)
        o['op'] = m.op;
    if (m.field !== undefined)
        o['field'] = queryFieldRefToJson(m.field);
    if (m.alias !== undefined)
        o['alias'] = m.alias;
    return o;
}
export function queryAggregationFromJson(o) {
    var _a, _b;
    return {
        op: (_a = o['op']) !== null && _a !== void 0 ? _a : 'AGGREGATION_OP_UNSPECIFIED',
        field: o['field'] ? queryFieldRefFromJson(o['field']) : undefined,
        alias: (_b = o['alias']) !== null && _b !== void 0 ? _b : '',
    };
}
export function queryJoinToJson(m) {
    const o = {};
    if (m.associationType !== undefined)
        o['associationType'] = m.associationType;
    if (m.direction !== undefined)
        o['direction'] = m.direction;
    if (m.target !== undefined)
        o['target'] = queryObjectRefToJson(m.target);
    if (m.filters !== undefined)
        o['filters'] = filterGroupToJson(m.filters);
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.associationTags !== undefined) {
        o['associationTags'] = m.associationTags.map(e => e);
    }
    if (m.joins !== undefined) {
        o['joins'] = m.joins.map(e => queryJoinToJson(e));
    }
    return o;
}
export function queryJoinFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        associationType: (_a = o['associationType']) !== null && _a !== void 0 ? _a : '',
        direction: (_b = o['direction']) !== null && _b !== void 0 ? _b : 'JOIN_DIRECTION_UNSPECIFIED',
        target: o['target'] ? queryObjectRefFromJson(o['target']) : undefined,
        filters: o['filters'] ? filterGroupFromJson(o['filters']) : undefined,
        type: (_c = o['type']) !== null && _c !== void 0 ? _c : 'JOIN_TYPE_UNSPECIFIED',
        associationTags: ((_d = o['associationTags']) !== null && _d !== void 0 ? _d : []).map(e => e),
        joins: ((_e = o['joins']) !== null && _e !== void 0 ? _e : []).map(e => queryJoinFromJson(e)),
    };
}
export function crmQueryToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.root !== undefined)
        o['root'] = queryObjectRefToJson(m.root);
    if (m.filters !== undefined)
        o['filters'] = filterGroupToJson(m.filters);
    if (m.joins !== undefined) {
        o['joins'] = m.joins.map(e => queryJoinToJson(e));
    }
    if (m.select !== undefined) {
        o['select'] = m.select.map(e => queryFieldRefToJson(e));
    }
    if (m.aggregate !== undefined) {
        o['aggregate'] = m.aggregate.map(e => queryAggregationToJson(e));
    }
    if (m.groupBy !== undefined) {
        o['groupBy'] = m.groupBy.map(e => queryFieldRefToJson(e));
    }
    if (m.orderBy !== undefined) {
        o['orderBy'] = m.orderBy.map(e => querySortToJson(e));
    }
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function crmQueryFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        root: o['root'] ? queryObjectRefFromJson(o['root']) : undefined,
        filters: o['filters'] ? filterGroupFromJson(o['filters']) : undefined,
        joins: ((_b = o['joins']) !== null && _b !== void 0 ? _b : []).map(e => queryJoinFromJson(e)),
        select: ((_c = o['select']) !== null && _c !== void 0 ? _c : []).map(e => queryFieldRefFromJson(e)),
        aggregate: ((_d = o['aggregate']) !== null && _d !== void 0 ? _d : []).map(e => queryAggregationFromJson(e)),
        groupBy: ((_e = o['groupBy']) !== null && _e !== void 0 ? _e : []).map(e => queryFieldRefFromJson(e)),
        orderBy: ((_f = o['orderBy']) !== null && _f !== void 0 ? _f : []).map(e => querySortFromJson(e)),
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function queryCellToJson(m) {
    const o = {};
    if (m.object !== undefined)
        o['object'] = m.object;
    if (m.value !== undefined)
        o['value'] = fieldValueToJson(m.value);
    if (m.alias !== undefined)
        o['alias'] = m.alias;
    return o;
}
export function queryCellFromJson(o) {
    var _a, _b;
    return {
        object: (_a = o['object']) !== null && _a !== void 0 ? _a : '',
        value: o['value'] ? fieldValueFromJson(o['value']) : undefined,
        alias: (_b = o['alias']) !== null && _b !== void 0 ? _b : '',
    };
}
export function queryRowToJson(m) {
    const o = {};
    if (m.values !== undefined) {
        o['values'] = m.values.map(e => queryCellToJson(e));
    }
    return o;
}
export function queryRowFromJson(o) {
    var _a;
    return {
        values: ((_a = o['values']) !== null && _a !== void 0 ? _a : []).map(e => queryCellFromJson(e)),
    };
}
export function queryExecutionMetadataToJson(m) {
    const o = {};
    if (m.tier !== undefined)
        o['tier'] = m.tier;
    if (m.storesUsed !== undefined) {
        o['storesUsed'] = m.storesUsed.map(e => e);
    }
    if (m.totalLatencyMs !== undefined)
        o['totalLatencyMs'] = m.totalLatencyMs;
    return o;
}
export function queryExecutionMetadataFromJson(o) {
    var _a, _b, _c;
    return {
        tier: (_a = o['tier']) !== null && _a !== void 0 ? _a : 'QUERY_TIER_UNSPECIFIED',
        storesUsed: ((_b = o['storesUsed']) !== null && _b !== void 0 ? _b : []).map(e => e),
        totalLatencyMs: (_c = o['totalLatencyMs']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function resolvedQueryFieldToJson(m) {
    const o = {};
    if (m.object !== undefined)
        o['object'] = m.object;
    if (m.input !== undefined)
        o['input'] = m.input;
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    return o;
}
export function resolvedQueryFieldFromJson(o) {
    var _a, _b, _c;
    return {
        object: (_a = o['object']) !== null && _a !== void 0 ? _a : '',
        input: (_b = o['input']) !== null && _b !== void 0 ? _b : '',
        fieldId: (_c = o['fieldId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function executeCrmQueryRequestToJson(m) {
    const o = {};
    if (m.query !== undefined)
        o['query'] = crmQueryToJson(m.query);
    return o;
}
export function executeCrmQueryRequestFromJson(o) {
    return {
        query: o['query'] ? crmQueryFromJson(o['query']) : undefined,
    };
}
export function executeCrmQueryResponseToJson(m) {
    const o = {};
    if (m.rows !== undefined) {
        o['rows'] = m.rows.map(e => queryRowToJson(e));
    }
    if (m.execution !== undefined)
        o['execution'] = queryExecutionMetadataToJson(m.execution);
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function executeCrmQueryResponseFromJson(o) {
    var _a;
    return {
        rows: ((_a = o['rows']) !== null && _a !== void 0 ? _a : []).map(e => queryRowFromJson(e)),
        execution: o['execution'] ? queryExecutionMetadataFromJson(o['execution']) : undefined,
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function queryPlanNodeToJson(m) {
    const o = {};
    if (m.nodeType !== undefined)
        o['nodeType'] = m.nodeType;
    if (m.relation !== undefined)
        o['relation'] = m.relation;
    if (m.index !== undefined)
        o['index'] = m.index;
    if (m.estimatedRows !== undefined)
        o['estimatedRows'] = m.estimatedRows;
    if (m.children !== undefined) {
        o['children'] = m.children.map(e => queryPlanNodeToJson(e));
    }
    return o;
}
export function queryPlanNodeFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        nodeType: (_a = o['nodeType']) !== null && _a !== void 0 ? _a : '',
        relation: (_b = o['relation']) !== null && _b !== void 0 ? _b : '',
        index: (_c = o['index']) !== null && _c !== void 0 ? _c : '',
        estimatedRows: (_d = o['estimatedRows']) !== null && _d !== void 0 ? _d : 0,
        children: ((_e = o['children']) !== null && _e !== void 0 ? _e : []).map(e => queryPlanNodeFromJson(e)),
    };
}
export function explainCrmQueryRequestToJson(m) {
    const o = {};
    if (m.query !== undefined)
        o['query'] = crmQueryToJson(m.query);
    if (m.includeDatabasePlan !== undefined)
        o['includeDatabasePlan'] = m.includeDatabasePlan;
    return o;
}
export function explainCrmQueryRequestFromJson(o) {
    var _a;
    return {
        query: o['query'] ? crmQueryFromJson(o['query']) : undefined,
        includeDatabasePlan: (_a = o['includeDatabasePlan']) !== null && _a !== void 0 ? _a : false,
    };
}
export function explainCrmQueryResponseToJson(m) {
    const o = {};
    if (m.tier !== undefined)
        o['tier'] = m.tier;
    if (m.storesUsed !== undefined) {
        o['storesUsed'] = m.storesUsed.map(e => e);
    }
    if (m.rejections !== undefined) {
        o['rejections'] = m.rejections.map(e => e);
    }
    if (m.resolvedFields !== undefined) {
        o['resolvedFields'] = m.resolvedFields.map(e => resolvedQueryFieldToJson(e));
    }
    if (m.databasePlan !== undefined)
        o['databasePlan'] = queryPlanNodeToJson(m.databasePlan);
    return o;
}
export function explainCrmQueryResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        tier: (_a = o['tier']) !== null && _a !== void 0 ? _a : 'QUERY_TIER_UNSPECIFIED',
        storesUsed: ((_b = o['storesUsed']) !== null && _b !== void 0 ? _b : []).map(e => e),
        rejections: ((_c = o['rejections']) !== null && _c !== void 0 ? _c : []).map(e => e),
        resolvedFields: ((_d = o['resolvedFields']) !== null && _d !== void 0 ? _d : []).map(e => resolvedQueryFieldFromJson(e)),
        databasePlan: o['databasePlan'] ? queryPlanNodeFromJson(o['databasePlan']) : undefined,
    };
}
export function crmQueryableFieldToJson(m) {
    const o = {};
    if (m.field !== undefined)
        o['field'] = fieldSchemaToJson(m.field);
    if (m.alias !== undefined)
        o['alias'] = m.alias;
    if (m.queryable !== undefined)
        o['queryable'] = m.queryable;
    if (m.valueType !== undefined)
        o['valueType'] = m.valueType;
    if (m.operators !== undefined) {
        o['operators'] = m.operators.map(e => e);
    }
    if (m.aggregations !== undefined) {
        o['aggregations'] = m.aggregations.map(e => e);
    }
    if (m.fieldOptions !== undefined) {
        o['fieldOptions'] = m.fieldOptions.map(e => e);
    }
    return o;
}
export function crmQueryableFieldFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        field: o['field'] ? fieldSchemaFromJson(o['field']) : undefined,
        alias: (_a = o['alias']) !== null && _a !== void 0 ? _a : '',
        queryable: (_b = o['queryable']) !== null && _b !== void 0 ? _b : false,
        valueType: (_c = o['valueType']) !== null && _c !== void 0 ? _c : '',
        operators: ((_d = o['operators']) !== null && _d !== void 0 ? _d : []).map(e => e),
        aggregations: ((_e = o['aggregations']) !== null && _e !== void 0 ? _e : []).map(e => e),
        fieldOptions: ((_f = o['fieldOptions']) !== null && _f !== void 0 ? _f : []).map(e => e),
    };
}
export function crmObjectTypeSchemaToJson(m) {
    const o = {};
    if (m.objectType !== undefined)
        o['objectType'] = m.objectType;
    if (m.customObjectType !== undefined)
        o['customObjectType'] = customObjectTypeToJson(m.customObjectType);
    if (m.queryable !== undefined)
        o['queryable'] = m.queryable;
    if (m.fields !== undefined) {
        o['fields'] = m.fields.map(e => crmQueryableFieldToJson(e));
    }
    return o;
}
export function crmObjectTypeSchemaFromJson(o) {
    var _a, _b, _c;
    return {
        objectType: (_a = o['objectType']) !== null && _a !== void 0 ? _a : '',
        customObjectType: o['customObjectType'] ? customObjectTypeFromJson(o['customObjectType']) : undefined,
        queryable: (_b = o['queryable']) !== null && _b !== void 0 ? _b : false,
        fields: ((_c = o['fields']) !== null && _c !== void 0 ? _c : []).map(e => crmQueryableFieldFromJson(e)),
    };
}
export function crmRelationshipToJson(m) {
    const o = {};
    if (m.associationType !== undefined)
        o['associationType'] = m.associationType;
    if (m.fromObjectType !== undefined)
        o['fromObjectType'] = m.fromObjectType;
    if (m.toObjectType !== undefined)
        o['toObjectType'] = m.toObjectType;
    return o;
}
export function crmRelationshipFromJson(o) {
    var _a, _b, _c;
    return {
        associationType: (_a = o['associationType']) !== null && _a !== void 0 ? _a : '',
        fromObjectType: (_b = o['fromObjectType']) !== null && _b !== void 0 ? _b : '',
        toObjectType: (_c = o['toObjectType']) !== null && _c !== void 0 ? _c : '',
    };
}
export function describeCrmSchemaRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.objectType !== undefined)
        o['objectType'] = m.objectType;
    if (m.customObjectTypeId !== undefined)
        o['customObjectTypeId'] = m.customObjectTypeId;
    if (m.includeFieldOptions !== undefined)
        o['includeFieldOptions'] = m.includeFieldOptions;
    if (m.fieldIds !== undefined) {
        o['fieldIds'] = m.fieldIds.map(e => e);
    }
    return o;
}
export function describeCrmSchemaRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        objectType: (_b = o['objectType']) !== null && _b !== void 0 ? _b : '',
        customObjectTypeId: (_c = o['customObjectTypeId']) !== null && _c !== void 0 ? _c : '',
        includeFieldOptions: (_d = o['includeFieldOptions']) !== null && _d !== void 0 ? _d : false,
        fieldIds: ((_e = o['fieldIds']) !== null && _e !== void 0 ? _e : []).map(e => e),
    };
}
export function describeCrmSchemaResponseToJson(m) {
    const o = {};
    if (m.objectTypes !== undefined) {
        o['objectTypes'] = m.objectTypes.map(e => crmObjectTypeSchemaToJson(e));
    }
    if (m.relationships !== undefined) {
        o['relationships'] = m.relationships.map(e => crmRelationshipToJson(e));
    }
    return o;
}
export function describeCrmSchemaResponseFromJson(o) {
    var _a, _b;
    return {
        objectTypes: ((_a = o['objectTypes']) !== null && _a !== void 0 ? _a : []).map(e => crmObjectTypeSchemaFromJson(e)),
        relationships: ((_b = o['relationships']) !== null && _b !== void 0 ? _b : []).map(e => crmRelationshipFromJson(e)),
    };
}
export function getCrmObjectsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.objectType !== undefined)
        o['objectType'] = m.objectType;
    if (m.customObjectTypeId !== undefined)
        o['customObjectTypeId'] = m.customObjectTypeId;
    if (m.ids !== undefined) {
        o['ids'] = m.ids.map(e => e);
    }
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function getCrmObjectsRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        objectType: (_b = o['objectType']) !== null && _b !== void 0 ? _b : '',
        customObjectTypeId: (_c = o['customObjectTypeId']) !== null && _c !== void 0 ? _c : '',
        ids: ((_d = o['ids']) !== null && _d !== void 0 ? _d : []).map(e => e),
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function getCrmObjectsResponseToJson(m) {
    const o = {};
    if (m.crmObjects !== undefined) {
        o['crmObjects'] = m.crmObjects.map(e => crmObjectToJson(e));
    }
    if (m.fieldSchemas !== undefined) {
        o['fieldSchemas'] = m.fieldSchemas.map(e => fieldSchemaToJson(e));
    }
    return o;
}
export function getCrmObjectsResponseFromJson(o) {
    var _a, _b;
    return {
        crmObjects: ((_a = o['crmObjects']) !== null && _a !== void 0 ? _a : []).map(e => crmObjectFromJson(e)),
        fieldSchemas: ((_b = o['fieldSchemas']) !== null && _b !== void 0 ? _b : []).map(e => fieldSchemaFromJson(e)),
    };
}
export function crmMutationResultToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.error !== undefined)
        o['error'] = m.error;
    return o;
}
export function crmMutationResultFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        error: (_b = o['error']) !== null && _b !== void 0 ? _b : '',
    };
}
export function crmObjectMutationToJson(m) {
    const o = {};
    if (m.op !== undefined)
        o['op'] = m.op;
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.idempotencyId !== undefined)
        o['idempotencyId'] = m.idempotencyId;
    if (m.fields !== undefined) {
        o['fields'] = m.fields.map(e => fieldValueToJson(e));
    }
    if (m.externalId !== undefined)
        o['externalId'] = m.externalId;
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    return o;
}
export function crmObjectMutationFromJson(o) {
    var _a, _b, _c, _d;
    return {
        op: (_a = o['op']) !== null && _a !== void 0 ? _a : 'CRM_OBJECT_MUTATION_OP_INVALID',
        id: (_b = o['id']) !== null && _b !== void 0 ? _b : '',
        idempotencyId: (_c = o['idempotencyId']) !== null && _c !== void 0 ? _c : '',
        fields: ((_d = o['fields']) !== null && _d !== void 0 ? _d : []).map(e => fieldValueFromJson(e)),
        externalId: o['externalId'],
        ownerId: o['ownerId'],
    };
}
export function mutateCrmObjectsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.objectType !== undefined)
        o['objectType'] = m.objectType;
    if (m.customObjectTypeId !== undefined)
        o['customObjectTypeId'] = m.customObjectTypeId;
    if (m.validateOnly !== undefined)
        o['validateOnly'] = m.validateOnly;
    if (m.ops !== undefined) {
        o['ops'] = m.ops.map(e => crmObjectMutationToJson(e));
    }
    return o;
}
export function mutateCrmObjectsRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        objectType: (_b = o['objectType']) !== null && _b !== void 0 ? _b : '',
        customObjectTypeId: (_c = o['customObjectTypeId']) !== null && _c !== void 0 ? _c : '',
        validateOnly: (_d = o['validateOnly']) !== null && _d !== void 0 ? _d : false,
        ops: ((_e = o['ops']) !== null && _e !== void 0 ? _e : []).map(e => crmObjectMutationFromJson(e)),
    };
}
export function mutateCrmObjectsResponseToJson(m) {
    const o = {};
    if (m.partial !== undefined)
        o['partial'] = m.partial;
    if (m.results !== undefined) {
        o['results'] = m.results.map(e => crmMutationResultToJson(e));
    }
    return o;
}
export function mutateCrmObjectsResponseFromJson(o) {
    var _a, _b;
    return {
        partial: (_a = o['partial']) !== null && _a !== void 0 ? _a : false,
        results: ((_b = o['results']) !== null && _b !== void 0 ? _b : []).map(e => crmMutationResultFromJson(e)),
    };
}
export function associationMutationToJson(m) {
    const o = {};
    if (m.op !== undefined)
        o['op'] = m.op;
    if (m.associationType !== undefined)
        o['associationType'] = m.associationType;
    if (m.fromId !== undefined)
        o['fromId'] = m.fromId;
    if (m.toId !== undefined)
        o['toId'] = m.toId;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    if (m.associationId !== undefined)
        o['associationId'] = m.associationId;
    return o;
}
export function associationMutationFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        op: (_a = o['op']) !== null && _a !== void 0 ? _a : 'ASSOCIATION_MUTATION_OP_INVALID',
        associationType: (_b = o['associationType']) !== null && _b !== void 0 ? _b : '',
        fromId: (_c = o['fromId']) !== null && _c !== void 0 ? _c : '',
        toId: (_d = o['toId']) !== null && _d !== void 0 ? _d : '',
        tags: ((_e = o['tags']) !== null && _e !== void 0 ? _e : []).map(e => e),
        associationId: (_f = o['associationId']) !== null && _f !== void 0 ? _f : '',
    };
}
export function mutateAssociationsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.ops !== undefined) {
        o['ops'] = m.ops.map(e => associationMutationToJson(e));
    }
    if (m.validateOnly !== undefined)
        o['validateOnly'] = m.validateOnly;
    return o;
}
export function mutateAssociationsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        ops: ((_b = o['ops']) !== null && _b !== void 0 ? _b : []).map(e => associationMutationFromJson(e)),
        validateOnly: (_c = o['validateOnly']) !== null && _c !== void 0 ? _c : false,
    };
}
export function mutateAssociationsResponseToJson(m) {
    const o = {};
    if (m.partial !== undefined)
        o['partial'] = m.partial;
    if (m.results !== undefined) {
        o['results'] = m.results.map(e => crmMutationResultToJson(e));
    }
    return o;
}
export function mutateAssociationsResponseFromJson(o) {
    var _a, _b;
    return {
        partial: (_a = o['partial']) !== null && _a !== void 0 ? _a : false,
        results: ((_b = o['results']) !== null && _b !== void 0 ? _b : []).map(e => crmMutationResultFromJson(e)),
    };
}
export function fieldSchemaOpToJson(m) {
    const o = {};
    if (m.op !== undefined)
        o['op'] = m.op;
    if (m.field !== undefined)
        o['field'] = fieldSchemaToJson(m.field);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function fieldSchemaOpFromJson(o) {
    var _a;
    return {
        op: (_a = o['op']) !== null && _a !== void 0 ? _a : 'FIELD_SCHEMA_OP_TYPE_INVALID',
        field: o['field'] ? fieldSchemaFromJson(o['field']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function applyFieldSchemaRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.objectType !== undefined)
        o['objectType'] = m.objectType;
    if (m.customObjectTypeId !== undefined)
        o['customObjectTypeId'] = m.customObjectTypeId;
    if (m.fieldOps !== undefined) {
        o['fieldOps'] = m.fieldOps.map(e => fieldSchemaOpToJson(e));
    }
    if (m.validateOnly !== undefined)
        o['validateOnly'] = m.validateOnly;
    return o;
}
export function applyFieldSchemaRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        objectType: (_b = o['objectType']) !== null && _b !== void 0 ? _b : '',
        customObjectTypeId: (_c = o['customObjectTypeId']) !== null && _c !== void 0 ? _c : '',
        fieldOps: ((_d = o['fieldOps']) !== null && _d !== void 0 ? _d : []).map(e => fieldSchemaOpFromJson(e)),
        validateOnly: (_e = o['validateOnly']) !== null && _e !== void 0 ? _e : false,
    };
}
export function applyFieldSchemaResponseToJson(m) {
    const o = {};
    if (m.partial !== undefined)
        o['partial'] = m.partial;
    if (m.results !== undefined) {
        o['results'] = m.results.map(e => crmMutationResultToJson(e));
    }
    return o;
}
export function applyFieldSchemaResponseFromJson(o) {
    var _a, _b;
    return {
        partial: (_a = o['partial']) !== null && _a !== void 0 ? _a : false,
        results: ((_b = o['results']) !== null && _b !== void 0 ? _b : []).map(e => crmMutationResultFromJson(e)),
    };
}
export function applyCustomObjectTypeRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.customObjectType !== undefined)
        o['customObjectType'] = customObjectTypeToJson(m.customObjectType);
    if (m.fieldOps !== undefined) {
        o['fieldOps'] = m.fieldOps.map(e => fieldSchemaOpToJson(e));
    }
    if (m.validateOnly !== undefined)
        o['validateOnly'] = m.validateOnly;
    return o;
}
export function applyCustomObjectTypeRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        customObjectType: o['customObjectType'] ? customObjectTypeFromJson(o['customObjectType']) : undefined,
        fieldOps: ((_b = o['fieldOps']) !== null && _b !== void 0 ? _b : []).map(e => fieldSchemaOpFromJson(e)),
        validateOnly: (_c = o['validateOnly']) !== null && _c !== void 0 ? _c : false,
    };
}
export function applyCustomObjectTypeResponseToJson(m) {
    const o = {};
    if (m.customObjectType !== undefined)
        o['customObjectType'] = customObjectTypeToJson(m.customObjectType);
    if (m.partial !== undefined)
        o['partial'] = m.partial;
    if (m.results !== undefined) {
        o['results'] = m.results.map(e => crmMutationResultToJson(e));
    }
    return o;
}
export function applyCustomObjectTypeResponseFromJson(o) {
    var _a, _b;
    return {
        customObjectType: o['customObjectType'] ? customObjectTypeFromJson(o['customObjectType']) : undefined,
        partial: (_a = o['partial']) !== null && _a !== void 0 ? _a : false,
        results: ((_b = o['results']) !== null && _b !== void 0 ? _b : []).map(e => crmMutationResultFromJson(e)),
    };
}
export function promoteToContactRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.potentialContactId !== undefined)
        o['potentialContactId'] = m.potentialContactId;
    return o;
}
export function promoteToContactRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        potentialContactId: (_b = o['potentialContactId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function promoteToContactResponseToJson(m) {
    const o = {};
    if (m.contactId !== undefined)
        o['contactId'] = m.contactId;
    return o;
}
export function promoteToContactResponseFromJson(o) {
    var _a;
    return {
        contactId: (_a = o['contactId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function dismissPotentialContactRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.potentialContactId !== undefined)
        o['potentialContactId'] = m.potentialContactId;
    return o;
}
export function dismissPotentialContactRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        potentialContactId: (_b = o['potentialContactId']) !== null && _b !== void 0 ? _b : '',
    };
}
